/* sm-herbergi-vel.js - SMHerb 1.0.0, v\u00e9l herbergisn\u00famera og skilta fyrir r\u00fdmi.
   Skilti og merkingar, 2026-09-28. ES5, ein IIFE, ASCII \u00ed bygg\u00f0u skr\u00e1nni.

   Sama v\u00e9lin teiknar forsko\u00f0unina, m\u00e6lir br\u00fdrnar og b\u00fdr til framlei\u00f0sluskr\u00e1na:
   - Letri\u00f0 er lesi\u00f0 me\u00f0 opentype.js \u00far s\u00f6mu skr\u00e1m og SMFram notar
     (sm-letur-<id>.json, sm-letur-rounded-elegance-open.js), svo t\u00f6lurnar \u00ed
     forsko\u00f0uninni eru n\u00e1kv\u00e6mlega s\u00f6mu ferlar og \u00ed skr\u00e1nni.
   - Sta\u00f0a hvers stafs er reiknu\u00f0 h\u00e9r (kerning + stafabil) og fer til SMFram
     sem "stafir" (algild x \u00ed mm). Skr\u00e1in fylgir \u00fev\u00ed forsko\u00f0uninni upp \u00e1 punkt.
   - Allt sem er skori\u00f0 \u00ed pl\u00f6tuna (stafir, g\u00f6t fyrir tappa) \u00fearf minnst 3,0 mm
     af efni \u00e1 milli s\u00edn og vi\u00f0 br\u00fan (VEFUR, eigandinn 2026-09-28). V\u00e9lin b\u00e6tir
     vi\u00f0 stafabili e\u00f0a minnkar letri\u00f0; dugi \u00fea\u00f0 ekki neitar h\u00fan ("of_langt").
     Sama m\u00e6ling er ger\u00f0 aftur \u00e1 SVG skr\u00e1nni sj\u00e1lfri \u00e1\u00f0ur en h\u00fan fer \u00ed k\u00f6rfu.
   - Engar eyjur: loka\u00f0ur hluti pl\u00f6tu innan \u00ed skur\u00f0i er villa ("eyja").

   H\u00e1\u00f0: window.opentype (sm-opentype.min.js) og window.ClipperLib
   (sm-clipper.min.js). SMHerb.hlada() s\u00e6kir \u00feau og letri\u00f0 eftir
   window.SMFramSlodir (snippets/sm-framleidsla.liquid).
   1.2.0 (2026-09-29): t\u00e1kn, skorinn texti undir, l\u00edna og br\u00fdr >= 1,3 mm (sj\u00e1 uppsetning2 ne\u00f0ar).
   BUILT FILE: live body + herbergi-takn/smidi/plastrar (python3 apply.py base out). */
(function (W) {
  "use strict";
  var UTGAFA = "1.3.1", SNID = "herbergisnumer@1";
  var VEFUR = 3.0;        /* minnsta efni milli skur\u00f0a og vi\u00f0 br\u00fan, mm (eigandinn 2026-09-28) */
  var GAT_R = 4;          /* gat fyrir tappa, 8 mm (eigandinn) */
  var HETTA_R = 6;        /* hetta tappans, 12 mm (eigandinn 2026-09-28), a\u00f0eins \u00ed forsko\u00f0un og \u00ed reglunni um grafinn texta vi\u00f0 g\u00f6t */
  var HETTA_BIL = 1;      /* minnsta bil grafins texta \u00fat fyrir hettuna, mm (sama og skorinn texti f\u00e6r: GAT_R + VEFUR = HETTA_R + 1) */
  /* Skuggi \u00e1 vegginn, \u00ed mm (sama l\u00edkan og t\u00f6lur og h\u00fasn\u00famerin, sm-husnumer.css): lj\u00f3s ofan fr\u00e1, \u00ferj\u00fa l\u00f6g sem
     margfeldi af fjarl\u00e6g\u00f0inni z fr\u00e1 veggnum, [ni\u00f0ur, sigma, \u00f3gagns\u00e6i]: 0,7 z / 0,625 z, 0,25 z / 0,25 z,
     0,08 z / 0,065 z. Tappinn er 25 mm fr\u00e1 vegg a\u00f0 hettu, platan sv\u00edfur um 2 cm fr\u00e1 veggnum (z = 20); l\u00edmd
     plata liggur fl\u00f6t og a\u00f0eins 3 mm br\u00fanin varpar skugga (z = 3, tv\u00f6 ystu l\u00f6gin). */
  var SKUGGI = { tappar: { z: 20, a: [0.30, 0.20, 0.16] }, lim: { z: 3, a: [0.16, 0.14] } };
  var SKUGGI_LOG = [[0.7, 0.625], [0.25, 0.25], [0.08, 0.065]];
  var HORN = 2;           /* hornrad\u00edus platna, mm */
  var RAMMI_INN = 3;      /* grafni ramminn (L\u00cdNA) er 3 mm fr\u00e1 br\u00fan pl\u00f6tunnar (eigandinn 2026-09-29); textasv\u00e6\u00f0i\u00f0 fylgir gamla rammanum */
  var BIL_SKRA = 10;      /* bil milli stykkja \u00ed skr\u00e1nni, mm */
  var LEIT = 5;           /* leitarrad\u00edus vefm\u00e6lingar, mm (brei\u00f0ara efni en \u00feetta skiptir ekki m\u00e1li) */
  var MJOTT = 1.0;        /* minnsta br\u00fa og r\u00e6ma undir kommu innan eins stafs, mm (eins og h\u00fasn\u00famerin, MJOTT_GOLF) */
  var MIN_SKORID = 10;    /* minnsta h\u00e1stafah\u00e6\u00f0 skorins texta, mm (eigandinn 2026-09-28) */
  var BIL_HLUTFALL = 0.05; /* minnsta bil milli stafa sem hlutfall af h\u00e6\u00f0 \u00feeirra, \u00feegar \u00fea\u00f0 er meira en VEFUR (eigandinn 2026-09-28, eins og t\u00f6lurnar \u00e1 h\u00fasn\u00famerunum) */
  var MIN_GRAFA = 6;      /* minnsta h\u00e1stafah\u00e6\u00f0 grafins a\u00f0altexta, mm */
  var MIN_UNDIR = 2.6;    /* minnsta h\u00e1stafah\u00e6\u00f0 textans undir, mm */

  var STAERDIR = {
    "90x90": { b: 90, h: 90, tappar: 0 },
    "140x140": { b: 140, h: 140, tappar: 4 },
    "140x190": { b: 140, h: 190, tappar: 2 },
    "190x190": { b: 190, h: 190, tappar: 4 },
    "290x140": { b: 290, h: 140, tappar: 4 },
    "290x190": { b: 290, h: 190, tappar: 4 },
    "140x90": { b: 140, h: 90, tappar: 2 }   /* 1.3.0: l\u00edti\u00f0 aflangt (eigandinn 01.10), 2 tappar til hli\u00f0anna */
  };
  var GERDIR = {
    hnota: { lag: 2, skorid: true },
    akryl: { lag: 2, skorid: true },
    stok: { lag: 1, skorid: true },
    tvilitt: { lag: 1, skorid: false }
  };
  /* einlitt akr\u00fdl, 3 mm (lager: fj\u00f3rir litir, eigandinn 2026-09-27) */
  var AKRYL = {
    "svart-matt": { heiti: "Svart matt", dokkt: true, glans: false, fylling: "#1e1e20", kantur: "#3b3b3e", kodi: "SM" },
    "svart-glans": { heiti: "Svart glans", dokkt: true, glans: true, fylling: "#1a1917", kantur: "#46443f", kodi: "SG" },
    "hvitt-matt": { heiti: "Hv\u00edtt matt", dokkt: false, glans: false, fylling: "#f8f8f6", kantur: "#d4d3cf", kodi: "HM" },
    "hvitt-glans": { heiti: "Hv\u00edtt glans", dokkt: false, glans: true, fylling: "#ffffff", kantur: "#cfcfcc", kodi: "HG" }
  };
  /* tv\u00edlitt akr\u00fdl: yfirbor\u00f0 og kjarni (textalitir hur\u00f0askiltanna, sm-hurda-config.js MAT) */
  var TVILITT = {
    gull: { heiti: "Gull", kjarni: "#1a1815", dokkt: false, kodi: "GG" },
    silfur: { heiti: "Silfur", kjarni: "#1a1815", dokkt: false, kodi: "GSI" },
    svart: { heiti: "Svart", kjarni: "#ffffff", dokkt: true, kodi: "GS" },
    hvitt: { heiti: "Hv\u00edtt", kjarni: "#1a1815", dokkt: false, kodi: "GH" }
  };
  var LETUR = { reo: "rounded-elegance-open", cormorant: "cormorantgaramond-600", jost: "jost-500" };
  var LETUR_HEITI = { reo: "Rounded Elegance Open", cormorant: "Cormorant Garamond", jost: "Jost", didot: "SM Didot" };
  /* 14.10: Klassiskt = SM Didot (sama skra og husnumerin, sm-letur-smdidot-400.json). Grafid (tvilitt) notar letrid sjalft,
     skorid i gegn (hnota, akryl, an baks) bruarutgafuna (hvert lokad gat hefur bru, eins og husnumeraplotur). */
  LETUR.didot = "smdidot-400";
  var LETUR_BRYR = { didot: "smdidot-400-bryr" };
  /* letrid sem honnunin notar: reo (og eldri gildi) nakvaemlega eins og adur, didot eftir thvi hvort er skorid */
  function leturAf(s, skorid) {
    if (s && s.letur === "didot") return skorid ? LETUR_BRYR.didot : LETUR.didot;
    return skorid ? LETUR.reo : (LETUR[s && s.letur] || LETUR.reo);
  }
  /* letur sem eru alltaf i hastofum (Rounded Elegance Open, eigandinn 2026-09-28; SM Didot eins, sama utlit textans) */
  function hastafir(id) { return id === LETUR.reo || id === LETUR.didot || id === LETUR_BRYR.didot; }
  function leturLysing(s, skorid) { return s.letur === "didot" ? (skorid ? "SM Didot me\u00f0 br\u00fam" : LETUR_HEITI.didot) : (LETUR_HEITI[s.letur] || LETUR_HEITI.reo); }
  var FESTING = { lim: "L\u00edm \u00e1 bakhli\u00f0", silfur: "Silfur tappar", svart: "Svartir tappar" };
  var GERD_HEITI = { hnota: "\u00c1 hnotu", akryl: "\u00c1 akr\u00fdli", stok: "\u00c1n baks", tvilitt: "Tv\u00edlitt grafi\u00f0" };
  /* leyf\u00f0ir stafir (\u00e1\u00e6tlun 2.3) auk punkts og mi\u00f0punkts \u00ed textanum undir */
  var LEYFT_AD = /^[0-9A-Za-z\u00c1\u00c9\u00cd\u00d3\u00da\u00dd\u00de\u00c6\u00d6\u00d0\u00e1\u00e9\u00ed\u00f3\u00fa\u00fd\u00fe\u00e6\u00f6\u00f0 &\/-]$/;
  var LEYFT_UNDIR = /^[0-9A-Za-z\u00c1\u00c9\u00cd\u00d3\u00da\u00dd\u00de\u00c6\u00d6\u00d0\u00e1\u00e9\u00ed\u00f3\u00fa\u00fd\u00fe\u00e6\u00f6\u00f0 &\/.,\u00b7-]$/;

  function tala(v) { return typeof v === "number" && isFinite(v); }
  function f2(n) { var v = Math.round(n * 100) / 100; return String(v === 0 ? 0 : v); }
  function f3(n) { var v = Math.round(n * 1000) / 1000; return String(v === 0 ? 0 : v); }
  function nfc(s) { s = String(s == null ? "" : s); try { if (s.normalize) s = s.normalize("NFC"); } catch (e) {} return s; }
  /* h\u00e1stafir \u00e1 \u00edslensku (1:1 fyrir alla leyf\u00f0a stafi) */
  function upp(s) { try { return s.toLocaleUpperCase("is"); } catch (e) { return s.toUpperCase(); } }
  function hreinsa(s) { return nfc(s).replace(/[\r\n\t]+/g, " ").replace(/\s+/g, " ").replace(/^\s+|\s+$/g, ""); }
  function R(x, y, w, h, r) { return { x: x, y: y, w: w, h: h, r: r == null ? HORN : r }; }
  function inn(r, m) { return R(r.x + m, r.y + m, Math.max(0, r.w - 2 * m), Math.max(0, r.h - 2 * m), r.r); }
  function skurdur(a, b) { var x = Math.max(a.x, b.x), y = Math.max(a.y, b.y); return R(x, y, Math.min(a.x + a.w, b.x + b.w) - x, Math.min(a.y + a.h, b.y + b.h) - y, 0); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* ---------------------------------------------------------------- letur */
  var F = {};           /* id -> { font, upem, cap, gl: {index: {c: cmds(1 em), p: polys(1 em), bb}} } */
  function b64Buf(b64) {
    if (W.atob) {
      var s = W.atob(b64), n = s.length, u = new Uint8Array(n);
      for (var i = 0; i < n; i++) u[i] = s.charCodeAt(i);
      return u.buffer;
    }
    var B = Buffer.from(b64, "base64"); /* Node (t\u00f6flur og pr\u00f3fanir) */
    return B.buffer.slice(B.byteOffset, B.byteOffset + B.length);
  }
  function skraLetur(id, buf) {
    var font = W.opentype.parse(buf);
    var os2 = font.tables && font.tables.os2, cap = os2 && os2.sCapHeight ? os2.sCapHeight : 0;
    if (!cap) { var H = font.charToGlyph("H").getBoundingBox(); cap = H.y2 || font.unitsPerEm * 0.7; }
    F[id] = { id: id, font: font, upem: font.unitsPerEm, cap: cap / font.unitsPerEm, gl: {} };
    return F[id];
  }
  function lesaLeturTexta(txt) {
    var m = /"b64"\s*:\s*"([A-Za-z0-9+\/=]+)"/.exec(txt) || /b64\s*:\s*['"]([A-Za-z0-9+\/=]+)['"]/.exec(txt);
    if (!m) throw new Error("SMHerb: letur finnst ekki");
    return b64Buf(m[1]);
  }
  var hlodst = {};
  function hladaSkrift(url, glob) {
    if (W[glob]) return Promise.resolve(W[glob]);
    if (hlodst[url]) return hlodst[url];
    hlodst[url] = new Promise(function (res, rej) {
      var s = document.createElement("script");
      s.src = url; s.async = true;
      s.onload = function () { W[glob] ? res(W[glob]) : rej(new Error("SMHerb: " + glob)); };
      s.onerror = function () { delete hlodst[url]; rej(new Error("SMHerb: " + url)); };
      document.head.appendChild(s);
    });
    return hlodst[url];
  }
  var leturBid = {};
  function hladaLetur(id, slodir) {
    if (F[id]) return Promise.resolve(F[id]);
    if (leturBid[id]) return leturBid[id];
    var url = slodir && slodir.letur && slodir.letur[id];
    if (!url) return Promise.reject(new Error("SMHerb: engin sl\u00f3\u00f0 fyrir " + id));
    leturBid[id] = fetch(url, { credentials: "same-origin" }).then(function (r) {
      if (!r.ok) throw new Error("SMHerb: " + r.status + " " + id);
      return r.text();
    }).then(function (t) { return skraLetur(id, lesaLeturTexta(t)); });
    leturBid[id]["catch"](function () { delete leturBid[id]; });
    return leturBid[id];
  }
  /* s\u00e6kir opentype, Clipper og letri\u00f0 (ids) eftir window.SMFramSlodir */
  function hlada(ids, slodir) {
    slodir = slodir || W.SMFramSlodir || {};
    var a = [];
    if (!W.opentype) a.push(hladaSkrift(slodir.opentype, "opentype"));
    if (!W.ClipperLib) a.push(hladaSkrift(slodir.clipper, "ClipperLib"));
    return Promise.all(a).then(function () {
      return Promise.all((ids || []).map(function (id) { return hladaLetur(id, slodir); }));
    });
  }
  function hefurLetur(id) { return !!F[id]; }

  /* ferlar eins stafs \u00ed 1 em (y ni\u00f0ur), geymdir */
  function stafur(L, g) {
    var c = L.gl[g];
    if (c) return c;
    var p = L.font.glyphs.get(g).getPath(0, 0, 1), cmds = [];
    p.commands.forEach(function (k) {
      if (k.type === "Z") cmds.push({ t: "Z" });
      else if (k.type === "C") cmds.push({ t: "C", x1: k.x1, y1: k.y1, x2: k.x2, y2: k.y2, x: k.x, y: k.y });
      else if (k.type === "Q") cmds.push({ t: "Q", x1: k.x1, y1: k.y1, x: k.x, y: k.y });
      else cmds.push({ t: k.type, x: k.x, y: k.y });
    });
    var polys = flatten(cmds, 0.0004), bb = { x0: 1e9, y0: 1e9, x1: -1e9, y1: -1e9 };
    polys.forEach(function (pl) { pl.forEach(function (q) { if (q[0] < bb.x0) bb.x0 = q[0]; if (q[0] > bb.x1) bb.x1 = q[0]; if (q[1] < bb.y0) bb.y0 = q[1]; if (q[1] > bb.y1) bb.y1 = q[1]; }); });
    if (!polys.length) bb = null;
    return (L.gl[g] = { c: cmds, p: polys, bb: bb });
  }

  /* ---------------------------------------------------------------- ferlar */
  function flatC(p0, p1, p2, p3, out, tol, d) {
    var dx = p3[0] - p0[0], dy = p3[1] - p0[1], L = Math.sqrt(dx * dx + dy * dy) || 1e-12;
    var d1 = Math.abs((p1[0] - p3[0]) * dy - (p1[1] - p3[1]) * dx) / L, d2 = Math.abs((p2[0] - p3[0]) * dy - (p2[1] - p3[1]) * dx) / L;
    if (d > 16 || d1 + d2 <= tol) { out.push(p3); return; }
    var m = function (a, b) { return [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2]; };
    var p01 = m(p0, p1), p12 = m(p1, p2), p23 = m(p2, p3), p012 = m(p01, p12), p123 = m(p12, p23), mid = m(p012, p123);
    flatC(p0, p01, p012, mid, out, tol, d + 1); flatC(mid, p123, p23, p3, out, tol, d + 1);
  }
  function flatten(cmds, tol) {
    var polys = [], cur = null, pt = null;
    for (var i = 0; i < cmds.length; i++) {
      var c = cmds[i];
      if (c.t === "M") { if (cur && cur.length > 2) polys.push(cur); cur = [[c.x, c.y]]; pt = [c.x, c.y]; }
      else if (!cur) continue;
      else if (c.t === "L") { cur.push([c.x, c.y]); pt = [c.x, c.y]; }
      else if (c.t === "C") { flatC(pt, [c.x1, c.y1], [c.x2, c.y2], [c.x, c.y], cur, tol, 0); pt = [c.x, c.y]; }
      else if (c.t === "Q") { flatC(pt, [pt[0] + 2 / 3 * (c.x1 - pt[0]), pt[1] + 2 / 3 * (c.y1 - pt[1])], [c.x + 2 / 3 * (c.x1 - c.x), c.y + 2 / 3 * (c.y1 - c.y)], [c.x, c.y], cur, tol, 0); pt = [c.x, c.y]; }
      else if (c.t === "Z") { if (cur.length > 2) polys.push(cur); pt = cur[0]; cur = null; }
    }
    if (cur && cur.length > 2) polys.push(cur);
    return polys;
  }
  /* SVG d (M L H V C S Q T Z, algild og afst\u00e6\u00f0; SMFram skrifar m l h v c z) -> cmds */
  function lesaD(d) {
    var s = String(d || ""), i = 0, n = s.length, out = [], cmd = "", cx = 0, cy = 0, sx = 0, sy = 0, lc = null, lq = null;
    var bil = function () { while (i < n && /[\s,]/.test(s.charAt(i))) i++; };
    var erTala = function () { bil(); return i < n && /[-+.\d]/.test(s.charAt(i)); };
    var tal = function () { bil(); var m = /^[-+]?(?:\d+\.?\d*|\.\d+)(?:[eE][-+]?\d+)?/.exec(s.slice(i, i + 40)); if (!m) throw new Error("SMHerb: sl\u00f3\u00f0 " + i); i += m[0].length; return parseFloat(m[0]); };
    while (true) {
      bil(); if (i >= n) break;
      var ch = s.charAt(i);
      if (/[a-zA-Z]/.test(ch)) { cmd = ch; i++; } else if (!cmd) throw new Error("SMHerb: sl\u00f3\u00f0");
      var C = cmd.toUpperCase(), rel = cmd !== C, x, y, x1, y1, x2, y2;
      if (C === "Z") { out.push({ t: "Z" }); cx = sx; cy = sy; lc = lq = null; cmd = ""; continue; }
      do {
        if (C === "M") { x = tal(); y = tal(); if (rel) { x += cx; y += cy; } out.push({ t: "M", x: x, y: y }); cx = sx = x; cy = sy = y; C = "L"; cmd = rel ? "l" : "L"; lc = lq = null; }
        else if (C === "L") { x = tal(); y = tal(); if (rel) { x += cx; y += cy; } out.push({ t: "L", x: x, y: y }); cx = x; cy = y; lc = lq = null; }
        else if (C === "H") { x = tal(); if (rel) x += cx; out.push({ t: "L", x: x, y: cy }); cx = x; lc = lq = null; }
        else if (C === "V") { y = tal(); if (rel) y += cy; out.push({ t: "L", x: cx, y: y }); cy = y; lc = lq = null; }
        else if (C === "C" || C === "S") {
          if (C === "C") { x1 = tal(); y1 = tal(); if (rel) { x1 += cx; y1 += cy; } } else { x1 = lc ? 2 * cx - lc[0] : cx; y1 = lc ? 2 * cy - lc[1] : cy; }
          x2 = tal(); y2 = tal(); x = tal(); y = tal();
          if (rel) { x2 += cx; y2 += cy; x += cx; y += cy; }
          out.push({ t: "C", x1: x1, y1: y1, x2: x2, y2: y2, x: x, y: y }); lc = [x2, y2]; lq = null; cx = x; cy = y;
        } else if (C === "Q" || C === "T") {
          if (C === "Q") { x1 = tal(); y1 = tal(); if (rel) { x1 += cx; y1 += cy; } } else { x1 = lq ? 2 * cx - lq[0] : cx; y1 = lq ? 2 * cy - lq[1] : cy; }
          x = tal(); y = tal(); if (rel) { x += cx; y += cy; }
          out.push({ t: "Q", x1: x1, y1: y1, x: x, y: y }); lq = [x1, y1]; lc = null; cx = x; cy = y;
        } else throw new Error("SMHerb: \u00f3\u00feekkt skipun " + cmd);
      } while (erTala());
    }
    return out;
  }
  function hringPoly(cx, cy, r, n) { var p = [], k; n = n || 72; for (k = 0; k < n; k++) p.push([cx + r * Math.cos(2 * Math.PI * k / n), cy + r * Math.sin(2 * Math.PI * k / n)]); return p; }

  /* ---------------------------------------------------------------- l\u00edna af texta
     Sta\u00f0a hvers stafs (penni) \u00ed mm fr\u00e1 upphafi l\u00ednunnar, grunnl\u00edna y = 0 (y ni\u00f0ur).
     Kerning \u00far GPOS/kern t\u00f6flunni, stafabil (em) \u00e1 eftir hverjum staf, engir bandstafir. */
  function lina(id, texti, mm, stafabil) {
    var L = F[id], font = L.font, sc = mm / L.upem, ls = (stafabil || 0) * mm;
    var chars = String(texti).split(""), gl = [], i, x = 0, vantar = [];
    var ix = chars.map(function (c) { var g = font.charToGlyphIndex(c === "\u00a0" ? " " : c); if (!g && c !== " ") vantar.push(c); return g; });
    var bb = { x0: 1e9, y0: 1e9, x1: -1e9, y1: -1e9 };
    for (i = 0; i < chars.length; i++) {
      var g = ix[i], G = g ? font.glyphs.get(g) : null, adv = G ? (G.advanceWidth || 0) * sc : mm * 0.25;
      var k = (i + 1 < chars.length && g && ix[i + 1]) ? (font.getKerningValue(g, ix[i + 1]) || 0) * sc : 0;
      var bil = chars[i] === " ";
      gl.push({ c: chars[i], g: g, x: x, bil: bil });
      if (!bil && g) {
        var S = stafur(L, g);
        if (S.bb) {
          if (x + S.bb.x0 * mm < bb.x0) bb.x0 = x + S.bb.x0 * mm;
          if (x + S.bb.x1 * mm > bb.x1) bb.x1 = x + S.bb.x1 * mm;
          if (S.bb.y0 * mm < bb.y0) bb.y0 = S.bb.y0 * mm;
          if (S.bb.y1 * mm > bb.y1) bb.y1 = S.bb.y1 * mm;
        }
      }
      x += adv + k + ls;
    }
    if (bb.x0 > bb.x1) bb = { x0: 0, y0: -L.cap * mm, x1: 0, y1: 0 };
    return { id: id, mm: mm, stafabil: stafabil || 0, gl: gl, breidd: x, blek: bb, vantar: vantar };
  }
  /* setur l\u00ednu \u00feannig a\u00f0 mi\u00f0ja blekkassans lendi \u00e1 cx og efri br\u00fan bleksins \u00e1 y0 */
  function stadsetja(Ln, cx, y0) {
    Ln.x0 = cx - (Ln.blek.x0 + Ln.blek.x1) / 2;
    Ln.y = y0 - Ln.blek.y0;
    Ln.stafir = Ln.gl.map(function (g) { return Ln.x0 + g.x; });
    Ln.kassi = { x: Ln.x0 + Ln.blek.x0, y: Ln.y + Ln.blek.y0, w: Ln.blek.x1 - Ln.blek.x0, h: Ln.blek.y1 - Ln.blek.y0 };
    return Ln;
  }
  /* marghyrningar stafanna \u00ed mm (einn h\u00f3pur \u00e1 staf) */
  function linuPolys(Ln) {
    var L = F[Ln.id], ut = [];
    Ln.gl.forEach(function (g, i) {
      if (g.bil || !g.g) return;
      var S = stafur(L, g.g), ox = Ln.stafir[i], oy = Ln.y, mm = Ln.mm;
      ut.push({ hopur: "s" + i, stafur: g.c, polys: S.p.map(function (pl) { return pl.map(function (q) { return [ox + q[0] * mm, oy + q[1] * mm]; }); }) });
    });
    return ut;
  }
  /* SVG d l\u00ednunnar (upprunalegir ferlar, 2 aukastafir) */
  function linuD(Ln, dx, dy) {
    var L = F[Ln.id], s = "";
    dx = dx || 0; dy = dy || 0;
    Ln.gl.forEach(function (g, i) {
      if (g.bil || !g.g) return;
      var S = stafur(L, g.g), ox = Ln.stafir[i] + dx, oy = Ln.y + dy, mm = Ln.mm;
      var X = function (v) { return f2(ox + v * mm); }, Y = function (v) { return f2(oy + v * mm); };
      S.c.forEach(function (k) {
        if (k.t === "Z") s += "Z";
        else if (k.t === "C") s += "C" + X(k.x1) + " " + Y(k.y1) + " " + X(k.x2) + " " + Y(k.y2) + " " + X(k.x) + " " + Y(k.y);
        else if (k.t === "Q") s += "Q" + X(k.x1) + " " + Y(k.y1) + " " + X(k.x) + " " + Y(k.y);
        else s += k.t + X(k.x) + " " + Y(k.y);
      });
    });
    return s;
  }

  /* ---------------------------------------------------------------- vefur (efni\u00f0 milli skur\u00f0a)
     holur: [{hopur, polys}] (hver h\u00f3pur sameina\u00f0ur s\u00e9r: einn stafur, eitt gat).
     M\u00e6lir: minnsta bil milli \u00f3l\u00edkra skur\u00f0a, minnstu br\u00fa innan sama skur\u00f0ar (tv\u00e6r
     hli\u00f0ar sama marghyrnings \u00fear sem lei\u00f0in eftir ja\u00f0rinum er margfalt lengri en
     beina l\u00ednan og mi\u00f0punkturinn er \u00ed efninu), bil a\u00f0 br\u00fan pl\u00f6tunnar, og eyjur. */
  function clipperSameina(polys) {
    var CL = W.ClipperLib, SC = 1e4, c = new CL.Clipper(), tree = new CL.PolyTree();
    var paths = polys.map(function (pl) { return pl.map(function (q) { return { X: Math.round(q[0] * SC), Y: Math.round(q[1] * SC) }; }); });
    c.AddPaths(paths, CL.PolyType.ptSubject, true);
    c.Execute(CL.ClipType.ctUnion, tree, CL.PolyFillType.pftNonZero, CL.PolyFillType.pftNonZero);
    var ytri = [], eyjur = 0;
    (function ganga(node) {
      node.Childs().forEach(function (ch) {
        var pts = ch.Contour().map(function (p) { return [p.X / SC, p.Y / SC]; });
        if (ch.IsHole()) eyjur++; else if (pts.length > 2) ytri.push(pts);
        ganga(ch);
      });
    })(tree);
    return { ytri: ytri, eyjur: eyjur };
  }
  function thetta(pts, mx) {
    var out = [], i, n = pts.length;
    for (i = 0; i < n; i++) {
      var a = pts[i], b = pts[(i + 1) % n], dx = b[0] - a[0], dy = b[1] - a[1], L = Math.sqrt(dx * dx + dy * dy), k = Math.max(1, Math.ceil(L / mx)), j;
      for (j = 0; j < k; j++) out.push([a[0] + dx * j / k, a[1] + dy * j / k]);
    }
    return out;
  }
  function inniI(p, pts) {
    var c = false, i, j, n = pts.length;
    for (i = 0, j = n - 1; i < n; j = i++) {
      var a = pts[i], b = pts[j];
      if (((a[1] > p[1]) !== (b[1] > p[1])) && (p[0] < (b[0] - a[0]) * (p[1] - a[1]) / (b[1] - a[1]) + a[0])) c = !c;
    }
    return c;
  }
  /* Vefm\u00e6ling (eigandinn 2026-09-28): tv\u00f6 g\u00f3lf. VEFUR (3,0 mm) milli a\u00f0skilinna skur\u00f0a, a\u00f0 br\u00fan pl\u00f6tunnar og
     a\u00f0 g\u00f6tum; MJOTT (1,0 mm) fyrir br\u00fa og r\u00e6mu undir kommu innan eins stafs (sama g\u00f3lf og \u00e1 h\u00fasn\u00famerunum).
     Bil milli tveggja stafa er auk \u00feess minnst o.golfMilli (5 % af h\u00e6\u00f0 stafanna \u00feegar \u00fea\u00f0 er meira en VEFUR,
     sama regla og t\u00f6lurnar \u00e1 h\u00fasn\u00famerunum). o.boga: bogaslaki innan sama ferils (mm); kalla\u00f0 me\u00f0
     min(6, 0,25 em), svo br\u00fdr \u00ed \u00c6, 8 og A finnist l\u00edka \u00ed sm\u00e1u letri (fastir 6 mm misstu af \u00feeim). */
  function vefur(holur, plata, svaedi, o) {
    o = o || {};
    var golfM = Math.max(VEFUR, o.golfMilli || 0);
    var P = [], eyjur = [], i, j, leit = Math.max(LEIT, o.leit || 0, golfM + 1), boga = o.boga != null ? o.boga : 6;
    holur.forEach(function (h) {
      var u = clipperSameina(h.polys);
      if (u.eyjur) eyjur.push(h.stafur || h.hopur);
      u.ytri.forEach(function (pts) {
        pts = thetta(pts, 1.5);
        var cum = [0], L = 0;
        for (var k = 1; k <= pts.length; k++) { var a = pts[k - 1], b = pts[k % pts.length]; L += Math.sqrt((b[0] - a[0]) * (b[0] - a[0]) + (b[1] - a[1]) * (b[1] - a[1])); cum.push(L); }
        var bb = { x0: 1e9, y0: 1e9, x1: -1e9, y1: -1e9 };
        pts.forEach(function (q) { if (q[0] < bb.x0) bb.x0 = q[0]; if (q[0] > bb.x1) bb.x1 = q[0]; if (q[1] < bb.y0) bb.y0 = q[1]; if (q[1] > bb.y1) bb.y1 = q[1]; });
        P.push({ pts: pts, cum: cum, L: L, hopur: h.hopur, gat: !!h.gat, stafur: h.stafur || "", bb: bb, boga: h.boga });
      });
    });
    /* hnitanet af l\u00ednub\u00fatum; talnalyklar og stimpill \u00ed sta\u00f0 strengja (sama ni\u00f0ursta\u00f0a, margfalt hra\u00f0ar) */
    var CELL = 2.5, net = {}, lykill = function (a, b) { return (a + 4096) * 8192 + (b + 4096); };
    var grunnur = [], nButa = 0;
    P.forEach(function (Q) { grunnur.push(nButa); nButa += Q.pts.length; });
    var butQ = new Int32Array(nButa), butS = new Int32Array(nButa), stimpill = new Int32Array(nButa), stimp = 0;
    P.forEach(function (Q, qi) {
      var n = Q.pts.length;
      for (var s = 0; s < n; s++) {
        var a = Q.pts[s], b = Q.pts[(s + 1) % n], gi = grunnur[qi] + s;
        butQ[gi] = qi; butS[gi] = s;
        var gx0 = Math.floor(Math.min(a[0], b[0]) / CELL), gx1 = Math.floor(Math.max(a[0], b[0]) / CELL);
        var gy0 = Math.floor(Math.min(a[1], b[1]) / CELL), gy1 = Math.floor(Math.max(a[1], b[1]) / CELL);
        for (var gx = gx0; gx <= gx1; gx++) for (var gy = gy0; gy <= gy1; gy++) { var kk = lykill(gx, gy); (net[kk] = net[kk] || []).push(gi); }
      }
    });
    /* \u00fer\u00edr m\u00e6lar: best = milli skur\u00f0a, a\u00f0 g\u00f6tum og br\u00fan (VEFUR); par = milli tveggja stafa (golfM, a\u00f0eins \u00feegar
       5 % reglan er strangari en VEFUR, annars segir best allt); mjo = innan eins stafs (MJOTT). Hver m\u00e6lir klippir
       leitina vi\u00f0 sitt eigi\u00f0 gildi. */
    var medPar = golfM > VEFUR;
    var best = { d: leit, flokkur: "", p: null, q: null, a: "", b: "" };
    var par = { d: leit, flokkur: "milli", p: null, q: null, a: "", b: "" };
    var mjo = { d: leit, flokkur: "innri", teg: "", p: null, q: null, a: "", b: "" };
    var skra = function (d, flokkur, p, q, a, b, teg) {
      if (flokkur === "innri") { if (d < mjo.d) mjo = { d: d, flokkur: "innri", teg: teg || "", p: p, q: q, a: a, b: b }; return; }
      if (d < best.d) best = { d: d, flokkur: flokkur, p: p, q: q, a: a, b: b };
      if (medPar && flokkur === "milli" && d < par.d) par = { d: d, flokkur: "milli", p: p, q: q, a: a, b: b };
    };
    var R_ = Math.ceil(leit / CELL);
    var utan = false;
    P.forEach(function (Pp, pi) {
      var n = Pp.pts.length;
      for (var k = 0; k < n; k++) {
        var p = Pp.pts[k];
        /* br\u00fan pl\u00f6tunnar */
        var dk = Math.min(p[0] - plata.x, plata.x + plata.w - p[0], p[1] - plata.y, plata.y + plata.h - p[1]);
        skra(dk, "kantur", p, null, Pp.stafur, "");
        if (svaedi && !Pp.gat) {
          var ds = Math.min(p[0] - svaedi.x, svaedi.x + svaedi.w - p[0], p[1] - svaedi.y, svaedi.y + svaedi.h - p[1]);
          if (ds < 1) utan = true;
        }
        var gx = Math.floor(p[0] / CELL), gy = Math.floor(p[1] / CELL);
        stimp++;
        for (var ax = gx - R_; ax <= gx + R_; ax++) for (var ay = gy - R_; ay <= gy + R_; ay++) {
          var listi = net[lykill(ax, ay)]; if (!listi) continue;
          for (var t = 0; t < listi.length; t++) {
            var gi = listi[t];
            if (stimpill[gi] === stimp) continue; stimpill[gi] = stimp;
            var qi = butQ[gi], s = butS[gi];
            var Q = P[qi], m = Q.pts.length, a = Q.pts[s], b = Q.pts[(s + 1) % m];
            var fl = qi === pi ? (Pp.gat ? "gat" : "innri") : ((Pp.gat || Q.gat) ? "gat" : (Pp.hopur === Q.hopur ? "innri" : "milli"));
            var takm = fl === "innri" ? mjo.d : (fl === "milli" && medPar ? Math.max(best.d, par.d) : best.d);
            var dx = b[0] - a[0], dy = b[1] - a[1], ll = dx * dx + dy * dy, u = ll ? ((p[0] - a[0]) * dx + (p[1] - a[1]) * dy) / ll : 0;
            if (u < 0) u = 0; else if (u > 1) u = 1;
            var qx = a[0] + u * dx, qy = a[1] + u * dy, d2 = (p[0] - qx) * (p[0] - qx) + (p[1] - qy) * (p[1] - qy);
            if (d2 >= takm * takm) continue;
            var d = Math.sqrt(d2);
            if (qi === pi) {
              var sq = Q.cum[s] + u * Math.sqrt(ll), arc = Math.abs(sq - Pp.cum[k]);
              arc = Math.min(arc, Pp.L - arc);
              if (arc <= 4 * d + (Pp.boga != null ? Pp.boga : boga)) continue;
              if (inniI([(p[0] + qx) / 2, (p[1] + qy) / 2], Pp.pts)) continue;
              skra(d, fl, p, [qx, qy], Pp.stafur, Pp.stafur, "bru");
            } else skra(d, fl, p, [qx, qy], Pp.stafur, Q.stafur, "hreimur");
          }
        }
      }
    });
    if (!medPar) par = null;
    var mjG = o.mjott || MJOTT, okB = best.d >= VEFUR - 1e-9, okP = !par || par.d >= golfM - 1e-9, okM = okB && okP, okI = mjo.d >= mjG - 1e-9;
    /* milli: s\u00e1 m\u00e6lir sem fellur (VEFUR fyrst), annars best; golfMilli: g\u00f3lf \u00feess m\u00e6lis */
    var milli = !okB ? best : (!okP ? par : best), gM = milli === par ? golfM : VEFUR;
    /* min/flokkur: \u00fea\u00f0 sem fellur (milli skur\u00f0a fyrst), annars \u00fea\u00f0 sem er n\u00e6st s\u00ednu g\u00f3lfi */
    var V = (!okM || (okI && milli.d / gM <= mjo.d / mjG)) ? milli : mjo;
    return { min: V.d, flokkur: V.flokkur, p: V.p, q: V.q, a: V.a, b: V.b, milli: milli, innri: mjo, par: par, golfMilli: golfM,
      okMilli: okM, okInnri: okI, eyjur: eyjur, utan: utan, ok: okM && okI && !eyjur.length && !utan };
  }

  /* ---------------------------------------------------------------- r\u00famfr\u00e6\u00f0i */
  function logunAf(S) { return S.b === S.h ? "ferhyrnt" : (S.b > S.h ? "larett" : "lodrett"); }
  function rumfraedi(s) {
    var S = STAERDIR[s.staerd], G = GERDIR[s.gerd];
    if (!S || !G) return null;
    var b = S.b, h = S.h, lg = logunAf(S), plata, bak = null;
    if (G.lag === 2) {
      if (lg === "ferhyrnt") { var k = Math.round(b / 14 * 2) / 2; plata = R(k, k, b - 2 * k, h - 2 * k); bak = R(0, 0, b, h); }
      else if (lg === "larett") { plata = R(0.1 * h, 0, b - 0.2 * h, h); bak = R(0, 0.125 * h, b, 0.75 * h); }
      else { plata = R(0.125 * b, 0, 0.75 * b, h); bak = R(0, 0.1 * b, b, h - 0.2 * b); }
    } else plata = R(0, 0, b, h);
    var O = bak ? skurdur(plata, bak) : R(plata.x, plata.y, plata.w, plata.h, 0);
    var got = [], tappar = s.festing && s.festing !== "lim" ? S.tappar : 0, e = G.lag === 2 ? 9 : 10;
    if (tappar === 4) got = [[O.x + e, O.y + e], [O.x + O.w - e, O.y + e], [O.x + e, O.y + O.h - e], [O.x + O.w - e, O.y + O.h - e]];
    else if (tappar === 2) got = O.w > O.h ? [[O.x + e, O.y + O.h / 2], [O.x + O.w - e, O.y + O.h / 2]] : [[O.x + O.w / 2, O.y + e], [O.x + O.w / 2, O.y + O.h - e]];
    var rammi = null, rammiLina = null;
    /* 1.3.1: textakassinn (rammi) er alltaf s\u00e1 sami, me\u00f0 og \u00e1n ramma (eigandinn 01.10); l\u00ednan sj\u00e1lf a\u00f0eins \u00feegar h\u00fan er valin */
    if (!G.skorid) {
      var fi = Math.min(plata.w, plata.h) / 14;
      if (got.length) fi = Math.max(fi, e + GAT_R + 3);
      rammi = R(plata.x + fi, plata.y + fi, plata.w - 2 * fi, plata.h - 2 * fi, 1.5);
    }
    if (!G.skorid && s.rammi) {
      /* l\u00ednan sj\u00e1lf: 3 mm inn, en me\u00f0 t\u00f6ppum gildir gatareglan \u00e1fram (minnst 3 mm innan vi\u00f0 g\u00f6tin) */
      var fl = RAMMI_INN;
      if (got.length) fl = Math.max(fl, e + GAT_R + 3);
      rammiLina = R(plata.x + fl, plata.y + fl, plata.w - 2 * fl, plata.h - 2 * fl, 1.5);
    }
    /* 1.3.0: s.grafa = allt grafi\u00f0 (h\u00f3telskilti): sama r\u00famfr\u00e6\u00f0i, ekkert skori\u00f0 \u00ed gegn, aldrei rammi utan tv\u00edlits */
    return { S: S, b: b, h: h, logun: lg, plata: plata, bak: bak, O: O, got: got, e: e, rammi: rammi, rammiLina: rammiLina, lag: G.lag, skorid: G.skorid && !s.grafa, grafa: !!s.grafa };
  }

  /* ---------------------------------------------------------------- uppsetning
     s: { gerd, staerd, festing, plata, bak, litur, letur, rammi, texti, undir }
     o: { anAthugunar: true } = bara m\u00e1tun (sm\u00e1myndir)
     Skilar U: r\u00famfr\u00e6\u00f0i, l\u00ednum (l1, l2), vef og villum [{kodi, ...}]. */
  /* mj\u00f3sta r\u00e6ma innan hvers h\u00e1stafs Rounded Elegance Open (br\u00fa e\u00f0a r\u00e6ma undir kommu), em, m\u00e6lt \u00e1 ferlum
     letursins (herbergisnumer/hastafir/lab/glyfur.cjs) og r\u00fanna\u00f0 ni\u00f0ur um 0,001. Taflan setur g\u00f3lf h\u00e6\u00f0arinnar:
     h\u00e6\u00f0 >= MJOTT / em x cap. */
  var BRYR_HERB = {"0":0.0719,"2":0.1188,"3":0.1113,"4":0.1003,"5":0.1127,"6":0.0719,"7":0.1291,"8":0.0714,"9":0.072,"A":0.072,"\u00c1":0.0694,"B":0.0713,"D":0.0713,"\u00d0":0.0703,"E":0.1159,"\u00c9":0.0683,"F":0.1159,"G":0.1185,"H":0.1187,"\u00cd":0.0688,"K":0.1127,"L":0.1176,"M":0.1191,"N":0.1185,"O":0.073,"\u00d3":0.0693,"P":0.0722,"R":0.0722,"S":0.1812,"T":0.1206,"U":0.2154,"\u00da":0.1343,"V":0.1106,"X":0.1331,"Y":0.1303,"\u00dd":0.1094,"Z":0.1142,"\u00de":0.0487,"\u00c6":0.0593,"\u00d6":0.0673,"&":0.0482};
  var SB0 = 0.04, SB_MAX = 0.45;   /* stafabil skorins texta, em */
  function uppsetning(s, o) {
    o = o || {};
    var g = rumfraedi(s);
    if (!g) return { ok: false, villur: [{ kodi: "ekki_i_bodi" }] };
    var U = { s: s, g: g, villur: [], l1: null, l2: null, vefur: null, ok: false };
    if (g.S.tappar === 0 && s.festing && s.festing !== "lim") { U.villur.push({ kodi: "festing" }); return U; }
    /* 1.2.0: t\u00e1kn, l\u00edna, e\u00f0a skorinn texti undir fara n\u00fdju lei\u00f0ina (uppsetning2); anna\u00f0 er \u00f3breytt */
    /* 1.3.0: s.undirGrafid = textinn undir er alltaf grafinn, l\u00edka undir skornu n\u00fameri (gamla lei\u00f0in, l2 grafin) */
    if (s.takn || (hreinsa(s.undir || "") && ((g.skorid && !s.undirGrafid) || s.lina))) return uppsetning2(s, o, g, U);
    var t1 = hreinsa(s.texti), t2 = hreinsa(s.undir || "");
    var id1 = leturAf(s, g.skorid), id2 = id1;
    /* Rounded Elegance Open er alltaf \u00ed h\u00e1st\u00f6fum (eigandinn 2026-09-28), l\u00edka \u00ed Tv\u00edlitt grafi\u00f0 */
    if (hastafir(id1)) { t1 = upp(t1); t2 = upp(t2); }
    U.texti = t1; U.undir = t2;
    if (!F[id1]) { U.villur.push({ kodi: "hledst" }); return U; }
    if (!t1) { U.villur.push({ kodi: "vantar_texti" }); return U; }
    var ogild = [], ogild2 = [];
    t1.split("").forEach(function (c) { if (!LEYFT_AD.test(c) && ogild.indexOf(c) < 0) ogild.push(c); });
    t2.split("").forEach(function (c) { if (!LEYFT_UNDIR.test(c) && ogild2.indexOf(c) < 0) ogild2.push(c); });
    if (ogild.length) U.villur.push({ kodi: "ogilt", reitur: "texti", takn: ogild.join(" ") });
    if (ogild2.length) U.villur.push({ kodi: "ogilt", reitur: "undir", takn: ogild2.join(" ") });
    if (U.villur.length) return U;

    /* textasv\u00e6\u00f0i\u00f0 */
    var base;
    if (g.skorid) base = g.O;
    else if (g.rammi) base = g.rammi;
    else if (g.got.length) base = inn(g.plata, g.e + GAT_R + 2);
    else base = g.plata;
    var m = g.skorid ? Math.max(5, 0.07 * Math.min(base.w, base.h)) : Math.max(3, 0.06 * Math.min(base.w, base.h));
    var Z = inn(base, m);
    if (g.skorid && g.got.length === 2 && g.got[0][0] === g.got[1][0]) {
      var efst = g.got[0][1] + GAT_R + VEFUR + 1.5, nedst = g.got[1][1] - GAT_R - VEFUR - 1.5;
      if (Z.y < efst) { Z.h -= efst - Z.y; Z.y = efst; }
      if (Z.y + Z.h > nedst) Z.h = nedst - Z.y;
    } else if (g.skorid && g.got.length === 2) {
      /* 1.3.1: tv\u00f6 g\u00f6t til hli\u00f0anna (140x90): textinn heldur sig innan vi\u00f0 \u00feau */
      var vinstra = g.got[0][0] + GAT_R + VEFUR + 1.5, haegra = g.got[1][0] - GAT_R - VEFUR - 1.5;
      if (Z.x < vinstra) { Z.w -= vinstra - Z.x; Z.x = vinstra; }
      if (Z.x + Z.w > haegra) Z.w = haegra - Z.x;
    }
    U.Z = Z;
    var L1 = F[id1], L2 = F[id2], cap1 = L1.cap, cap2 = L2.cap;
    /* minnsta h\u00e6\u00f0 sem mj\u00f3stu stafirnir \u00feola (a\u00f0eins skori\u00f0 letur) */
    var hStafa = 0, stafurMjor = "";
    if (g.skorid && id1 === LETUR.reo) t1.split("").forEach(function (c) { var e = BRYR_HERB[c]; if (e && MJOTT / e * cap1 > hStafa) { hStafa = MJOTT / e * cap1; stafurMjor = c; } });
    U.hStafa = +hStafa.toFixed(1);
    var h1max = Z.h * (t2 ? 0.55 : 0.62);
    var Wl = s.hamarkB > 0 ? Math.min(Z.w, s.hamarkB * g.S.b) : Z.w;   /* mesta breidd linu 1 */
    var cx = Z.x + Z.w / 2;

    function maata(sb, kv) {
      /* a\u00f0all\u00edna \u00ed einingarst\u00e6r\u00f0 (1 mm em) til a\u00f0 reikna breidd */
      var e1 = lina(id1, t1, 1, sb), w1 = e1.blek.x1 - e1.blek.x0;
      /* 14.10 (eigandi, textinn of storr): s.hamarkH / s.hamarkB = mesta hastafahaed og breidd adallinu sem hlutfall af haed og breidd
         plotunnar (g.S). Valfrjalst: an gildanna er velin ororeytt. kv minnkar hastafahaedina eins og adur. */
      var mm1 = Math.min(kv * Math.min(h1max, s.hamarkH > 0 ? s.hamarkH * g.S.h : 1e9) / cap1, Wl / Math.max(w1, 1e-6));
      var l1 = lina(id1, t1, mm1, sb), l2 = null, g12 = 0;
      if (t2) {
        var sb2 = 0.16, h2 = Math.min(s.undirHlutfall > 0 ? 14 : 9, Math.max(3.2, (s.undirHlutfall > 0 ? s.undirHlutfall : 0.17) * mm1 * cap1)), mm2 = h2 / cap2;
        var e2 = lina(id2, t2, 1, sb2), w2 = e2.blek.x1 - e2.blek.x0;
        if (w2 * mm2 > Z.w) mm2 = Z.w / w2;
        l2 = lina(id2, t2, mm2, sb2);
        g12 = 0.3 * mm1 * cap1;
      }
      var hb = function () { return (l1.blek.y1 - l1.blek.y0) + (l2 ? g12 + (l2.blek.y1 - l2.blek.y0) : 0); };
      var n = 0;
      while (hb() > Z.h && n++ < 12) {
        var f = Z.h / hb() * 0.995;
        mm1 *= f; l1 = lina(id1, t1, mm1, sb);
        if (l2) { l2 = lina(id2, t2, l2.mm * f, 0.16); g12 *= f; }
      }
      var y0 = Z.y + (Z.h - hb()) / 2;
      stadsetja(l1, cx, y0);
      if (l2) stadsetja(l2, cx, y0 + (l1.blek.y1 - l1.blek.y0) + g12);
      return { l1: l1, l2: l2 };
    }
    function holur(l1) {
      var h = linuPolys(l1);
      g.got.forEach(function (p, i) { h.push({ hopur: "g" + i, gat: true, stafur: "", polys: [hringPoly(p[0], p[1], GAT_R)] }); });
      return h;
    }
    function undirVandi(l2) {
      if (!l2) return null;
      if (l2.mm * cap2 < MIN_UNDIR - 1e-9) return "undir_langt";
      /* grafinn texti m\u00e1 ekki lenda undir hettu tappans n\u00e9 snerta hana: minnst HETTA_BIL \u00fat fyrir br\u00fan hennar */
      var k = l2.kassi;
      for (var i = 0; i < g.got.length; i++) {
        var p = g.got[i], nx = Math.max(k.x, Math.min(p[0], k.x + k.w)), ny = Math.max(k.y, Math.min(p[1], k.y + k.h));
        if (Math.sqrt((p[0] - nx) * (p[0] - nx) + (p[1] - ny) * (p[1] - ny)) < HETTA_R + HETTA_BIL) return "gat";
      }
      return null;
    }

    var sb = g.skorid ? SB0 : 0.02, kv = 1, r, V = null, it = 0;
    if (!g.skorid) {
      for (it = 0; it < 12; it++) {
        r = maata(sb, kv);
        var uv = undirVandi(r.l2);
        if (uv === "gat") { kv *= 0.93; continue; }
        break;
      }
      U.l1 = r.l1; U.l2 = r.l2;
      if (r.l1.mm * cap1 < MIN_GRAFA) U.villur.push({ kodi: "of_langt", grafid: true });
      if (undirVandi(r.l2)) U.villur.push({ kodi: "undir_langt" });
      U.ok = !U.villur.length;
      return U;
    }
    /* Skorinn texti (eigandinn 2026-09-28): stafabili\u00f0 breikkar og textinn minnkar \u00fear til hann passar, en
       stafirnir fara aldrei undir MIN_SKORID n\u00e9 \u00fe\u00e1 h\u00e6\u00f0 sem mj\u00f3stu stafirnir \u00feurfa (BRYR_HERB). */
    var hH = function () { return r.l1.mm * cap1; };
    for (it = 0; it < 40; it++) {
      r = maata(sb, kv);
      if (o.anAthugunar) { V = null; break; }
      V = vefur(holur(r.l1), g.plata, g.bak ? g.O : null, { boga: Math.min(6, 0.25 * r.l1.mm), golfMilli: BIL_HLUTFALL * hH() });
      var uv2 = undirVandi(r.l2);
      if (V.ok && !uv2) break;
      if (V.eyjur.length) break;
      if (hH() < MIN_SKORID - 1e-9 || hH() < hStafa - 1e-9) break;
      if (!V.okMilli && V.milli.flokkur === "milli") {
        /* brei\u00f0ara stafabil; skrefi\u00f0 tekur me\u00f0 a\u00f0 textinn minnkar um lei\u00f0 \u00feegar hann er bundinn af breiddinni */
        var mmN = r.l1.mm, gEm = V.milli.d / mmN, w1 = (r.l1.blek.x1 - r.l1.blek.x0) / mmN, nb = Math.max(1, t1.length - 1), mk = V.golfMilli + 0.1;
        var bundid = Math.abs(mmN * w1 - Wl) < 0.05 * Wl, nefn = Wl - mk * nb;
        var dsb = bundid && nefn > 0 ? (mk * w1 - gEm * Wl) / nefn : (mk / mmN - gEm);
        var nsb = sb + Math.max(0.005, dsb);
        if (nsb > SB_MAX) break;
        sb = nsb;
        continue;
      }
      if ((!V.okMilli && (V.milli.flokkur === "gat" || V.milli.flokkur === "kantur")) || V.utan || uv2 === "gat") { kv *= 0.95; if (kv < 0.4) break; continue; }
      break; /* br\u00fa e\u00f0a r\u00e6ma innan stafs undir MJOTT: textinn \u00feyrfti a\u00f0 vera st\u00e6rri */
    }
    U.l1 = r.l1; U.l2 = r.l2; U.vefur = V; U.umferdir = it;
    if (V) {
      /* krafan: l\u00e6sileiki (MIN_SKORID) og mj\u00f3stu stafirnir (BRYR_HERB) */
      var krafa = Math.max(MIN_SKORID, hStafa), takn = hStafa > MIN_SKORID ? stafurMjor : "";
      if (V.eyjur.length) U.villur.push({ kodi: "eyja", takn: V.eyjur.join(" ") });
      else if (!V.ok || hH() < krafa - 1e-9) U.villur.push({ kodi: "of_smatt", minst: Math.ceil(krafa * 10) / 10, takn: takn, flokkur: V.flokkur, vefur: V.min });
    }
    /* 1.2.0: br\u00fdr undir BRU (1,3 mm) eru breikka\u00f0ar og skilti\u00f0 m\u00e6lt aftur \u00e1 endanlegu formi. H\u00f6nnun \u00fear sem
       allar br\u00fdr eru BRU e\u00f0a brei\u00f0ari breytist ekki. */
    if (V && !U.villur.length && V.innri.d < BRU - 1e-9) {
      breikkaLinu(r.l1);
      var hb2 = linuPolysX(r.l1, "s");
      g.got.forEach(function (p, i) { hb2.push({ hopur: "g" + i, gat: true, stafur: "", polys: [hringPoly(p[0], p[1], GAT_R)] }); });
      var V2 = vefur(hb2, g.plata, g.bak ? g.O : null, { boga: Math.min(6, 0.25 * r.l1.mm), golfMilli: BIL_HLUTFALL * hH(), mjott: BRU });
      U.vefur = V2;
      if (!V2.ok) U.villur.push({ kodi: "of_smatt", minst: Math.ceil(Math.max(MIN_SKORID, hStafa) * 10) / 10, takn: hStafa > MIN_SKORID ? stafurMjor : "", flokkur: V2.flokkur, vefur: V2.min });
    }
    var uv3 = undirVandi(r.l2);
    if (uv3) U.villur.push({ kodi: uv3 === "gat" ? "of_langt" : uv3 });
    U.ok = !U.villur.length;
    return U;
  }

  /* ---------------------------------------------------------------- teikning (forsko\u00f0un)
     o: { id, slodir: { hnota, tvilitt: {gull@120x50: url, ...} }, skuggi (true), merkja (s\u00fdna mj\u00f3stu br\u00fa),
          smamynd (einfaldara), bil (sp\u00e1ss\u00eda mm) } */
  var nr = 0;
  function tvilittMynd(slodir, litur, w, h) {
    var t = (slodir && slodir.tvilitt) || {}, a = w / h, best = null, bd = 1e9;
    ["120x50", "120x75", "120x100"].forEach(function (k) { var p = k.split("x"), aa = +p[0] / +p[1], d = Math.abs(Math.log(aa / a)); if (t[litur + "@" + k] && d < bd) { bd = d; best = t[litur + "@" + k]; } });
    return best;
  }
  function rett(r, attr) {
    return '<rect x="' + f2(r.x) + '" y="' + f2(r.y) + '" width="' + f2(r.w) + '" height="' + f2(r.h) + '"' + (r.r ? ' rx="' + f2(r.r) + '"' : "") + (attr ? " " + attr : "") + "/>";
  }
  /* Tappinn er sami tappi og \u00e1 h\u00fasn\u00famerunum (assets/sm-husnumer.css, .hn-tappi), teikna\u00f0ur \u00ed SVG:
     l\u00ednustigull 155deg, keilustigull \u00ed fj\u00f3r\u00f0ungum (from 200deg) ofan \u00e1, 1 px d\u00f6kkur hringur, lj\u00f3s efri
     br\u00fan, d\u00f6kk ne\u00f0ri br\u00fan og skuggi undir. H\u00fasn\u00famerin teikna hringinn og skuggana \u00ed f\u00f6stum skj\u00e1pixlum
     (box-shadow), svo h\u00e9r eru \u00feeir reikna\u00f0ir \u00ed mm \u00fat fr\u00e1 pxmm (skj\u00e1pixlar \u00e1 mm \u00ed forsko\u00f0uninni).
     Keilustigull er ekki til \u00ed SVG: hann er mynd (keiluMynd) klippt a\u00f0 hringnum, e\u00f0a 120 fleygar \u00fear sem
     enginn canvas er til. */
  var TAPPI_LIT = {
    silfur: { lin: ["#c9c9c5", "#ababa7", "#8b8b88"], keila: [[255, 0.18], [0, 0.14], [255, 0.12], [0, 0.16], [255, 0.18]], skuggi: 0.36, hringur: 0.38, ljos: 0.5, dokk: 0.24 },
    svart: { lin: ["#484643", "#322f2d", "#1d1c1a"], keila: [[255, 0.11], [0, 0.18], [255, 0.07], [0, 0.2], [255, 0.11]], skuggi: 0.45, hringur: 0.6, ljos: 0.24, dokk: 0.35 }
  };
  function f3(n) { var v = Math.round(n * 1000) / 1000; return String(v === 0 ? 0 : v); }
  function hringD(cx, cy, r) {
    return "M" + f3(cx + r) + " " + f3(cy) + "a" + f3(r) + " " + f3(r) + " 0 1 0 " + f3(-2 * r) + " 0a" + f3(r) + " " + f3(r) + " 0 1 0 " + f3(2 * r) + " 0Z";
  }
  /* litur keilunnar m gr\u00e1\u00f0um eftir upphafinu (from 200deg): [gr\u00e1t\u00f3nn 0-255, alfa], forsamfellt (premultiplied) eins og CSS */
  function keiluLitur(K, m) {
    m = ((m % 360) + 360) % 360;
    var j = Math.min(3, Math.floor(m / 100)), s0 = K[j], s1 = K[j + 1], q = (m - j * 100) / (j === 3 ? 60 : 100);
    var al = s0[1] + (s1[1] - s0[1]) * q;
    return [Math.round((s0[0] * s0[1] + (s1[0] * s1[1] - s0[0] * s0[1]) * q) / al), al];
  }
  /* Keilustigullinn sem PNG (64 x 64), einu sinni fyrir hvorn lit. SVG fleygar m\u00e6tast \u00ed mi\u00f0junni og \u00fear
     leggst br\u00fanam\u00fdking \u00feeirra saman \u00ed d\u00f6kkan punkt; myndin er reiknu\u00f0 punkt fyrir punkt og hefur hann ekki. */
  var keiluMyndir = {};
  function keiluMynd(litur) {
    if (keiluMyndir[litur] !== undefined) return keiluMyndir[litur];
    var url = "";
    try {
      var doc = typeof document !== "undefined" ? document : null, cv = doc && doc.createElement ? doc.createElement("canvas") : null;
      var cx = cv && cv.getContext ? cv.getContext("2d") : null;
      if (cx) {
        var n = 64, K = TAPPI_LIT[litur].keila, im, x, y, i, v;
        cv.width = n; cv.height = n; im = cx.createImageData(n, n);
        for (y = 0; y < n; y++) for (x = 0; x < n; x++) {
          v = keiluLitur(K, Math.atan2(x + 0.5 - n / 2, n / 2 - y - 0.5) * 180 / Math.PI - 200);
          i = (y * n + x) * 4; im.data[i] = im.data[i + 1] = im.data[i + 2] = v[0]; im.data[i + 3] = Math.round(v[1] * 255);
        }
        cx.putImageData(im, 0, 0);
        url = cv.toDataURL("image/png");
        if (url.indexOf("data:image/png") !== 0) url = "";
      }
    } catch (e) { url = ""; }
    return (keiluMyndir[litur] = url);
  }
  function tappi(id, svartir, pxmm, sma) {
    var L = TAPPI_LIT[svartir ? "svart" : "silfur"], r = HETTA_R, u = 1 / pxmm, t = "", i;
    /* 155deg \u00e1 ferningi hettunnar (objectBoundingBox): stefna (sin 155, -cos 155), h\u00e1lf lengd (|sin|+|cos|)/2 */
    t += '<linearGradient id="' + id + 'tl" x1=".219187" y1="-.10221" x2=".780813" y2="1.10221">' +
      '<stop offset="0" stop-color="' + L.lin[0] + '"/><stop offset=".5" stop-color="' + L.lin[1] + '"/><stop offset="1" stop-color="' + L.lin[2] + '"/></linearGradient>';
    if (sma) {
      /* sm\u00e1mynd: hringur (1 skj\u00e1pixill utan vi\u00f0 hettuna) og l\u00ednustigullinn, s\u00f6mu litir */
      return { defs: t + '<g id="' + id + 'tg"><circle r="' + r + '" fill="none" stroke="#000" stroke-opacity="' + L.hringur + '" stroke-width="2" vector-effect="non-scaling-stroke"/>' +
        '<circle r="' + r + '" fill="url(#' + id + 'tl)"/></g>' };
    }
    t += '<clipPath id="' + id + 'tc"><circle r="' + r + '"/></clipPath>';
    t += '<filter id="' + id + 'tf" x="-100%" y="-100%" width="300%" height="300%"><feGaussianBlur stdDeviation="' + f3(2.5 * u) + '"/></filter>';
    t += '<filter id="' + id + 'tb" x="-100%" y="-100%" width="300%" height="300%"><feGaussianBlur stdDeviation="' + f3(u) + '"/></filter>';
    /* keilan: mynd reiknu\u00f0 punkt fyrir punkt (sama form\u00fala og CSS), annars 120 fleygar (t.d. \u00ed node) */
    var km = keiluMynd(svartir ? "svart" : "silfur"), k = "";
    if (km) k = '<image href="' + km + '" x="' + (-r) + '" y="' + (-r) + '" width="' + 2 * r + '" height="' + 2 * r + '" preserveAspectRatio="none"/>';
    else {
      var N = 120, R = r * 1.2, pt = [];
      for (i = 0; i <= N; i++) { var a = (200 + i * 360 / N) * Math.PI / 180; pt.push(f3(R * Math.sin(a)) + " " + f3(-R * Math.cos(a))); }
      for (i = 0; i < N; i++) {
        var kl = keiluLitur(L.keila, (i + 0.5) * 360 / N);
        k += '<path d="M0 0L' + pt[i] + "L" + pt[i + 1] + 'Z" fill="rgb(' + kl[0] + "," + kl[0] + "," + kl[0] + ')" fill-opacity="' + f3(kl[1]) + '"/>';
      }
    }
    var B = r + 6 * u, rammi = "M" + f3(-B) + " " + f3(-B) + "H" + f3(B) + "V" + f3(B) + "H" + f3(-B) + "Z";
    t += '<g id="' + id + 'tg">' +
      /* utan vi\u00f0 hettuna: hringurinn (0 0 0 1px) og skugginn (0 2px 5px) ofan \u00e1 honum */
      '<circle r="' + f3(r + u) + '" fill="#000" fill-opacity="' + L.hringur + '"/>' +
      '<circle cy="' + f3(2 * u) + '" r="' + r + '" fill="#000" fill-opacity="' + L.skuggi + '" filter="url(#' + id + 'tf)"/>' +
      /* hettan: l\u00ednustigull og keila */
      '<circle r="' + r + '" fill="url(#' + id + 'tl)"/>' +
      '<g clip-path="url(#' + id + 'tc)">' + k +
      /* inni \u00ed hettunni: d\u00f6kk ne\u00f0ri br\u00fan (inset 0 -2px 2px) og lj\u00f3s efri br\u00fan (inset 0 1px 0) */
      '<path d="' + rammi + hringD(0, -2 * u, r) + '" fill-rule="evenodd" fill="#000" fill-opacity="' + L.dokk + '" filter="url(#' + id + 'tb)"/>' +
      '<path d="' + rammi + hringD(0, u, r) + '" fill-rule="evenodd" fill="#fff" fill-opacity="' + L.ljos + '"/></g></g>';
    return { defs: t };
  }
  function teikna(U, o) {
    o = o || {};
    if (!U || !U.g) return "";
    var s = U.s, g = U.g, id = (o.id || "hb") + (++nr), bil = o.bil == null ? 8 : o.bil;
    var sma = !!o.smamynd, tappar = g.got.length > 0, festing = s.festing || "lim";
    var d = "", defs = "";
    var vb = [-bil, -bil, g.b + 2 * bil, g.h + 2 * bil];
    var ak = AKRYL[s.plata] || AKRYL["svart-matt"], tv = TVILITT[s.litur] || TVILITT.gull;
    var d1 = (U.l1 ? linuDX(U.l1) : "") + aukaD(U), d2 = U.l2 ? linuDX(U.l2) : "";
    if (U.l2skorid) { d1 += d2; d2 = ""; }
    var gotD = g.got.map(function (p) { return "M" + f2(p[0] + GAT_R) + " " + f2(p[1]) + "a" + GAT_R + " " + GAT_R + " 0 1 0 " + (-2 * GAT_R) + " 0a" + GAT_R + " " + GAT_R + " 0 1 0 " + (2 * GAT_R) + " 0Z"; }).join("");
    /* skuggar */
    if (!sma && o.skuggi !== false) {
      /* \u00ed mm, svo skugginn fylgir kvar\u00f0anum eins og platan (lj\u00f3s ofan fr\u00e1, sj\u00e1 SKUGGI) */
      var sk = SKUGGI[tappar ? "tappar" : "lim"], fm = "";
      defs += '<filter id="' + id + 'v" x="-30%" y="-30%" width="160%" height="170%" color-interpolation-filters="sRGB">';
      sk.a.forEach(function (a, i) {
        var L = SKUGGI_LOG[i];
        defs += '<feGaussianBlur in="SourceAlpha" stdDeviation="' + f3(L[1] * sk.z) + '"/><feOffset dx="0" dy="' + f3(L[0] * sk.z) + '"/>' +
          '<feComponentTransfer result="s' + i + '"><feFuncA type="linear" slope="' + a + '"/></feComponentTransfer>';
        fm = '<feMergeNode in="s' + i + '"/>' + fm;
      });
      defs += "<feMerge>" + fm + "</feMerge></filter>";
      d += '<g filter="url(#' + id + 'v)" fill="#000">' + (g.bak ? rett(g.bak) : "") + rett(g.plata) + "</g>";
    }
    /* baki\u00f0 */
    if (g.bak) {
      if (s.gerd === "hnota") {
        var snua = g.bak.h > g.bak.w;
        defs += '<pattern id="' + id + 'h" patternUnits="userSpaceOnUse" width="160" height="160"' + (snua ? ' patternTransform="rotate(90)"' : "") + '>' +
          (o.slodir && o.slodir.hnota ? '<image href="' + esc(o.slodir.hnota) + '" width="160" height="160" preserveAspectRatio="none"/>' : '<rect width="160" height="160" fill="#65452f"/>') + "</pattern>";
        d += rett(g.bak, 'fill="url(#' + id + 'h)"') + rett(inn(g.bak, 0.3), 'fill="none" stroke="#1c120b" stroke-opacity=".45" stroke-width=".6"');
      } else {
        var bk = AKRYL[s.bak] || AKRYL["hvitt-glans"];
        d += rett(g.bak, 'fill="' + bk.fylling + '"');
        if (bk.glans) d += rett(g.bak, 'fill="url(#' + id + 'l' + (bk.dokkt ? "d" : "l") + ')"');
        d += rett(inn(g.bak, 0.25), 'fill="none" stroke="' + bk.kantur + '" stroke-width=".5"');
      }
    }
    /* glj\u00e1i */
    defs += '<linearGradient id="' + id + 'll" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#e9e9e7"/><stop offset=".38" stop-color="#fff"/><stop offset=".47" stop-color="#f4f4f2"/><stop offset=".53" stop-color="#fff"/><stop offset="1" stop-color="#ececea"/></linearGradient>';
    defs += '<linearGradient id="' + id + 'ld" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#33302b"/><stop offset=".4" stop-color="#0d0c0b"/><stop offset=".47" stop-color="#2a2825"/><stop offset=".55" stop-color="#0a0908"/><stop offset="1" stop-color="#070605"/></linearGradient>';
    /* platan: akr\u00fdl (skori\u00f0 e\u00f0a allt grafi\u00f0, 1.3.0) e\u00f0a tv\u00edlitt */
    if (s.gerd !== "tvilitt") {
      var dSk = g.skorid ? d1 : "", dGr = (g.skorid ? "" : d1) + d2;
      defs += '<mask id="' + id + 'm" maskUnits="userSpaceOnUse" x="' + vb[0] + '" y="' + vb[1] + '" width="' + vb[2] + '" height="' + vb[3] + '">' + rett(g.plata, 'fill="#fff"') +
        (dSk ? '<path d="' + dSk + '" fill="#000"/>' : "") + (gotD ? '<path d="' + gotD + '" fill="#000"/>' : "") + "</mask>";
      if (!sma) {
        /* skuggi pl\u00f6tunnar \u00e1 bakinu (s\u00e9st inni \u00ed t\u00f6lunum og vi\u00f0 br\u00fanina) */
        defs += '<filter id="' + id + 'p" x="-10%" y="-10%" width="120%" height="125%"><feGaussianBlur in="SourceAlpha" stdDeviation=".55"/><feOffset dx=".45" dy=".9"/><feComponentTransfer><feFuncA type="linear" slope=".62"/></feComponentTransfer></filter>';
        d += '<g filter="url(#' + id + 'p)"><g mask="url(#' + id + 'm)">' + rett(g.plata, 'fill="#000"') + "</g></g>";
      }
      d += '<g mask="url(#' + id + 'm)">' + rett(g.plata, 'fill="' + (ak.glans ? "url(#" + id + (ak.dokkt ? "ld" : "ll") + ")" : ak.fylling) + '"') +
        rett(inn(g.plata, 0.25), 'fill="none" stroke="' + ak.kantur + '" stroke-width=".5"') + "</g>";
      /* s\u00e1ri\u00f0: lj\u00f3s br\u00fan \u00e1 skornu hli\u00f0inni sem sn\u00fdr a\u00f0 lj\u00f3sinu */
      if (dSk && !sma) d += '<path d="' + dSk + '" fill="none" stroke="' + (ak.dokkt ? "#5a5956" : "#ffffff") + '" stroke-opacity="' + (ak.dokkt ? ".55" : ".9") + '" stroke-width=".35" transform="translate(-.18 -.22)" mask="url(#' + id + 'm)"/>';
      /* grafinn texti (undir, e\u00f0a allt \u00feegar ekkert er skori\u00f0), \u00e1 einlitu akr\u00fdli: mattur og lj\u00f3s */
      if (dGr) {
        defs += '<filter id="' + id + 'g" x="-5%" y="-20%" width="110%" height="140%" color-interpolation-filters="sRGB"><feTurbulence type="fractalNoise" baseFrequency="3.2" numOctaves="2" seed="4" result="n"/>' +
          '<feColorMatrix in="n" type="matrix" values="0 0 0 0 ' + (ak.dokkt ? "0.6 0 0 0 0 0.59 0 0 0 0 0.57" : "0.35 0 0 0 0 0.33 0 0 0 0 0.3") + ' 0 0 0 ' + (ak.dokkt ? ".3" : ".45") + ' 0" result="m"/>' +
          '<feComposite in="m" in2="SourceAlpha" operator="in" result="k"/><feMerge><feMergeNode in="SourceGraphic"/><feMergeNode in="k"/></feMerge></filter>';
        d += '<path d="' + dGr + '" fill="' + (ak.dokkt ? "#4b4a47" : "#cfccc4") + '" filter="url(#' + id + 'g)"/>';
      }
    } else {
      var mynd = tvilittMynd(o.slodir, s.litur, g.plata.w, g.plata.h);
      defs += '<clipPath id="' + id + 'c">' + rett(g.plata) + "</clipPath>";
      d += '<g clip-path="url(#' + id + 'c)">' + rett(g.plata, 'fill="' + ({ gull: "#e2b98a", silfur: "#b8c0bc", svart: "#050505", hvitt: "#fbfbfb" }[s.litur] || "#ddd") + '"') +
        (mynd ? '<image href="' + esc(mynd) + '" x="' + f2(g.plata.x) + '" y="' + f2(g.plata.y) + '" width="' + f2(g.plata.w) + '" height="' + f2(g.plata.h) + '" preserveAspectRatio="xMidYMid slice"/>' : "") + "</g>";
      d += rett(inn(g.plata, 0.25), 'fill="none" stroke="' + (tv.dokkt ? "#3a3a3a" : "#00000026") + '" stroke-width=".5"');
      if (g.rammiLina) d += rett(g.rammiLina, 'fill="none" stroke="' + tv.kjarni + '" ' + (sma ? 'stroke-width="1" vector-effect="non-scaling-stroke"' : 'stroke-width=".3"'));
      if (d1) d += '<path d="' + d1 + '" fill="' + tv.kjarni + '"/>';
      if (d2) d += '<path d="' + d2 + '" fill="' + tv.kjarni + '"/>';
      if (gotD) d += '<path d="' + gotD + '" fill="#000" fill-opacity=".55"/>';
    }
    /* tappar (sama \u00fatlit og \u00e1 h\u00fasn\u00famerunum, sj\u00e1 tappi()) */
    if (tappar) {
      var T = tappi(id, festing === "svart", o.pxmm > 0 ? o.pxmm : 2.2, sma);
      defs += T.defs;
      g.got.forEach(function (p) { d += '<use href="#' + id + 'tg" x="' + f2(p[0]) + '" y="' + f2(p[1]) + '"/>'; });
    }
    /* mj\u00f3sti sta\u00f0urinn (a\u00f0eins \u00feegar hann er of mj\u00f3r) */
    /* a\u00f0eins \u00feegar h\u00f6nnuninni er hafna\u00f0 \u00ed raun (eigandinn 2026-09-28): textinn kemst ekki fyrir \u00fe\u00f3tt stafabili\u00f0
       breikki og hann minnki. o.merkja === "prof" s\u00fdnir hann alltaf (pr\u00f3fanir). */
    if ((o.merkja === "prof" || (o.merkja && !U.ok)) && U.vefur && !U.vefur.ok && U.vefur.p) {
      var mp = U.vefur.q ? [(U.vefur.p[0] + U.vefur.q[0]) / 2, (U.vefur.p[1] + U.vefur.q[1]) / 2] : U.vefur.p;
      d += '<circle cx="' + f2(mp[0]) + '" cy="' + f2(mp[1]) + '" r="5" fill="none" stroke="#e4572e" stroke-width="1" stroke-dasharray="2 1.4"/>';
    }
    var aria = o.aria != null ? o.aria : "";
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + vb.map(f2).join(" ") + '" width="' + f2(vb[2]) + '" height="' + f2(vb[3]) + '"' +
      /* skuggi tappanna n\u00e6r \u00fat fyrir 8 mm sp\u00e1ss\u00eduna; \u00e1n \u00feessa sker svg-i\u00f0 hann beint */
      (!sma && o.skuggi !== false ? ' overflow="visible"' : "") +
      (aria ? ' role="img" aria-label="' + esc(aria) + '"' : ' aria-hidden="true" focusable="false"') + ' data-b="' + g.b + '" data-h="' + g.h + '"><defs>' + defs + "</defs>" + d + "</svg>";
  }

  /* ---------------------------------------------------------------- framlei\u00f0sluskr\u00e1 (SMFram spec, mm)
     Platan \u00ed (0,0), baki\u00f0 h\u00e6gra megin vi\u00f0 hana me\u00f0 10 mm bili. Hvert stykki er
     sinn h\u00f3pur (PLATA, BAK), svo eigandinn tekur anna\u00f0 efni\u00f0 fr\u00e1 \u00e1\u00f0ur en hann sker. */
  function spec(U, lysing) {
    if (U && U.nyr) return spec2(U, lysing);
    if (!U || !U.ok || !U.l1) return null;
    var s = U.s, g = U.g, P = g.plata, B = g.bak, hl = [], dxP = -P.x, dyP = -P.y;
    var bx = P.w + BIL_SKRA, dxB = B ? bx - B.x : 0, dyB = B ? -B.y : 0;
    var T = function (Ln, lag, dx, dy) {
      if (Ln.breikkad) return linuHlutur(Ln, lag, dx, dy);
      return { gerd: "texti", lag: lag, hopur: "PLATA", texti: Ln.gl.map(function (x) { return x.c; }).join(""), letur: Ln.id, mm: +Ln.mm.toFixed(4), x: 0, y: +(Ln.y + dy).toFixed(4),
        stafir: Ln.stafir.map(function (v) { return +(v + dx).toFixed(4); }), bandstafir: false, kerning: false };
    };
    hl.push({ gerd: "rett", lag: "SKERA-YTRA", hopur: "PLATA", x: 0, y: 0, w: +P.w.toFixed(3), h: +P.h.toFixed(3), r: HORN });
    if (g.skorid) hl.push(T(U.l1, "SKERA-INNRA", dxP, dyP));
    else hl.push(T(U.l1, "GRAFA", dxP, dyP));
    if (U.l2) hl.push(T(U.l2, "GRAFA", dxP, dyP));
    if (g.rammiLina) hl.push({ gerd: "rett", lag: "LINA", hopur: "PLATA", x: +(g.rammiLina.x + dxP).toFixed(3), y: +(g.rammiLina.y + dyP).toFixed(3), w: +g.rammiLina.w.toFixed(3), h: +g.rammiLina.h.toFixed(3), r: g.rammiLina.r });
    g.got.forEach(function (p) { hl.push({ gerd: "hringur", lag: "SKERA-INNRA", hopur: "PLATA", cx: +(p[0] + dxP).toFixed(3), cy: +(p[1] + dyP).toFixed(3), r: GAT_R }); });
    if (B) {
      hl.push({ gerd: "rett", lag: "SKERA-YTRA", hopur: "BAK", x: bx, y: 0, w: +B.w.toFixed(3), h: +B.h.toFixed(3), r: HORN });
      g.got.forEach(function (p) { hl.push({ gerd: "hringur", lag: "SKERA-INNRA", hopur: "BAK", cx: +(p[0] + dxB).toFixed(3), cy: +(p[1] + dyB).toFixed(3), r: GAT_R }); });
    }
    var efni = s.gerd === "tvilitt" ? "tvilitt-" + s.litur : (s.gerd === "hnota" ? "hnota-" : s.gerd === "akryl" ? "akryl-" + s.bak + "-" : "") + s.plata;
    var mm2 = function (v) { return String(Math.round(v * 10) / 10).replace(".", ","); };
    var ly = [["Ger\u00f0", GERD_HEITI[s.gerd]]];
    if (g.skorid) ly.push(["PLATA", (AKRYL[s.plata] || {}).heiti + " akr\u00fdl 3 mm, " + mm2(P.w) + " x " + mm2(P.h) + " mm, n\u00fameri\u00f0 skori\u00f0 \u00ed gegn"]);
    else if (s.gerd !== "tvilitt") ly.push(["PLATA", (AKRYL[s.plata] || {}).heiti + " akr\u00fdl 3 mm, " + mm2(P.w) + " x " + mm2(P.h) + " mm, allt grafi\u00f0"]);
    else ly.push(["PLATA", "Tv\u00edlitt akr\u00fdl " + (TVILITT[s.litur] || {}).heiti + " 1,6 mm, " + mm2(P.w) + " x " + mm2(P.h) + " mm, textinn grafinn"]);
    if (B) ly.push(["BAK", (s.gerd === "hnota" ? "Hnota 3 mm" : (AKRYL[s.bak] || {}).heiti + " akr\u00fdl 3 mm") + ", " + mm2(B.w) + " x " + mm2(B.h) + " mm, x " + mm2(bx) + " mm \u00ed skr\u00e1nni"]);
    ly.push(["Festing", FESTING[s.festing || "lim"] + (g.got.length ? ", " + g.got.length + " g\u00f6t 8 mm" + (B ? " \u00ed gegnum b\u00e6\u00f0i l\u00f6g" : "") : "")]);
    ly.push(["Texti", U.texti]);
    if (U.l2) ly.push(["Texti undir", U.undir + " (grafinn)"]);
    if (!g.skorid || s.letur === "didot") ly.push(["Letur", leturLysing(s, g.skorid)]);
    if (g.rammiLina) ly.push(["Rammi", "LINA, " + mm2(g.rammiLina.x - P.x) + " mm fr\u00e1 br\u00fan"]);
    if (U.vefur) {
      var ymm = function (v) { return v >= LEIT ? "> " + LEIT : mm2(v); };
      ly.push(["Minnsta efni milli skur\u00f0a", ymm(U.vefur.milli.d) + " mm (l\u00e1gmark " + mm2(VEFUR) + " mm)"]);
      if (U.vefur.par) ly.push(["Minnsta bil milli stafa", ymm(U.vefur.par.d) + " mm (l\u00e1gmark " + mm2(U.vefur.golfMilli) + " mm, 5 % af stafah\u00e6\u00f0)"]);
      ly.push(["Mj\u00f3sta br\u00fa \u00ed staf", ymm(U.vefur.innri.d) + " mm (l\u00e1gmark " + mm2(U.l1.breikkad ? BRU : MJOTT) + " mm)"]);
    }
    (lysing || []).forEach(function (x) { ly.push(x); });
    return {
      vara: s.vara || "herbergisnumer", efni: efni, staerd: s.staerd, ord: U.texti,
      titill: (s.heiti || "Herbergisn\u00famer") + " " + U.texti + ", " + GERD_HEITI[s.gerd] + ", " + g.b / 10 + " x " + g.h / 10 + " cm",
      snid: SNID, w: +(B ? bx + B.w : P.w).toFixed(3), h: +Math.max(P.h, B ? B.h : 0).toFixed(3),
      lysing: ly,
      gogn: { v: UTGAFA, gerd: s.gerd, staerd: s.staerd, festing: s.festing || "lim", plata: s.gerd !== "tvilitt" ? s.plata : null, bak: s.gerd === "akryl" ? s.bak : null, grafa: !!s.grafa, undirGrafid: !!s.undirGrafid,
        litur: s.gerd === "tvilitt" ? s.litur : null, letur: s.letur === "didot" ? "didot" : (g.skorid ? "reo" : (s.letur || "reo")), rammi: !!g.rammiLina, texti: U.texti, undir: U.l2 ? U.undir : "",
        h1: +(U.l1.mm * F[U.l1.id].cap).toFixed(2), stafabil: U.l1.stafabil, vefur: U.vefur ? +U.vefur.milli.d.toFixed(2) : null,
        bil: U.vefur && U.vefur.par ? +U.vefur.par.d.toFixed(2) : null, bru: U.vefur ? +U.vefur.innri.d.toFixed(2) : null },
      hlutir: hl
    };
  }

  /* ---------------------------------------------------------------- athugun \u00e1 skr\u00e1nni sj\u00e1lfri
     Les SKERA h\u00f3pana \u00far SVG skr\u00e1 SMFram, sameinar skur\u00f0ina og m\u00e6lir vefinn og eyjur
     eins og \u00ed forsko\u00f0uninni. Skilar { ok, stykki: [{hopur, min, milli, bil, innri, eyjur}] }. */
  function hopEfni(svg, id) {
    var m = new RegExp('<g id="' + id + '">([\\s\\S]*?)</g>').exec(svg);
    return m ? m[1] : "";
  }
  function attr(el, n) { var m = new RegExp("\\s" + n + '="([^"]*)"').exec(el); return m ? parseFloat(m[1]) : 0; }
  function formPolys(txt, gotOut) {
    var out = [];
    (txt.match(/<(path|circle|rect|ellipse)\b[^>]*>/g) || []).forEach(function (el) {
      if (/^<path/.test(el)) { var dm = /\sd="([^"]*)"/.exec(el); if (dm) out = out.concat(flatten(lesaD(dm[1]), 0.01)); }
      else if (/^<circle/.test(el)) { out.push(hringPoly(attr(el, "cx"), attr(el, "cy"), attr(el, "r"), 96)); if (gotOut) gotOut[out.length - 1] = 1; }
      else if (/^<ellipse/.test(el)) { var cx = attr(el, "cx"), cy = attr(el, "cy"), rx = attr(el, "rx"), ry = attr(el, "ry"), p = []; for (var k = 0; k < 96; k++) p.push([cx + rx * Math.cos(2 * Math.PI * k / 96), cy + ry * Math.sin(2 * Math.PI * k / 96)]); out.push(p); }
      else { var x = attr(el, "x"), y = attr(el, "y"), w = attr(el, "width"), h = attr(el, "height"); out.push([[x, y], [x + w, y], [x + w, y + h], [x, y + h]]); }
    });
    return out;
  }
  /* Stafakassar \u00fatlitsins \u00ed hnitum skr\u00e1rinnar (platan \u00ed 0,0), svo skr\u00e1in s\u00e9 flokku\u00f0 eins og forsko\u00f0unin:
     hver ferill fer \u00ed h\u00f3p \u00feess stafs sem geymir mi\u00f0ju hans. */
  function stafaKassar(U) {
    var Ln = U && U.l1, L = Ln && F[Ln.id], P = U && U.g && U.g.plata, ut = [];
    if (!Ln || !L || !P) return ut;
    Ln.gl.forEach(function (g, i) {
      if (g.bil || !g.g) return;
      var S = stafur(L, g.g); if (!S.bb) return;
      var x = Ln.stafir[i] - P.x, y = Ln.y - P.y, mm = Ln.mm;
      ut.push({ i: i, c: g.c, x0: x + S.bb.x0 * mm, x1: x + S.bb.x1 * mm, y0: y + S.bb.y0 * mm, y1: y + S.bb.y1 * mm });
    });
    return ut;
  }
  /* G\u00f6t skr\u00e1rinnar: hringir (circle) e\u00f0a ferill sem fellur \u00e1 gat \u00fatlitsins (ef SMFram sameina\u00f0i h\u00f3pinn \u00ed eina sl\u00f3\u00f0). */
  function flokkaSkra(innra, got, kassar, gotU) {
    var hop = {}, rod = [];
    innra.forEach(function (pl, k) {
      var key, st = "", cx = 0, cy = 0, erGat = !!got[k];
      pl.forEach(function (q) { cx += q[0]; cy += q[1]; }); cx /= pl.length; cy /= pl.length;
      if (!erGat) gotU.forEach(function (p) { if (Math.abs(cx - p[0]) < 0.3 && Math.abs(cy - p[1]) < 0.3) erGat = true; });
      if (erGat) key = "g" + k;
      else {
        var best = null, bd = 1e9;
        kassar.forEach(function (b) {
          if (cx < b.x0 - 0.3 || cx > b.x1 + 0.3 || cy < b.y0 - 0.3 || cy > b.y1 + 0.3) return;
          var d = Math.abs(cx - (b.x0 + b.x1) / 2); if (d < bd) { bd = d; best = b; }
        });
        key = best ? "s" + best.i : "p" + k; st = best ? best.c : "";
      }
      if (!hop[key]) { hop[key] = { hopur: key, gat: erGat, stafur: st, polys: [] }; rod.push(key); }
      hop[key].polys.push(pl);
    });
    return rod.map(function (k) { return hop[k]; });
  }
  /* U (\u00fatliti\u00f0, uppsetning) flokkar skur\u00f0ina eftir st\u00f6fum: VEFUR milli skur\u00f0a, a\u00f0 br\u00fan og g\u00f6tum, bil milli stafa
     minnst BIL_HLUTFALL af stafah\u00e6\u00f0, MJOTT innan stafs. \u00c1n U (eldri k\u00f6ll) og \u00e1 BAK er allt einn h\u00f3pur og VEFUR
     gildir um allt, eins og \u00e1\u00f0ur (strangara, aldrei lausara). */
  /* Vikm\u00f6rk m\u00e6lingarinnar: skr\u00e1in er \u00e1 0,01 mm neti og ferlarnir eru marghyrningar innan 0,02 mm (sannreynir,
     umfer\u00f0 1: 0,05 mm hleypti 0,96 mm br\u00fa \u00ed gegn). */
  var SKRA_VIK = 0.02;
  function athugaSkra(svg, U) {
    var ut = { ok: true, stykki: [] }, kassar = stafaKassar(U);
    var P0 = U && U.g && U.g.plata, gotU = P0 ? U.g.got.map(function (p) { return [p[0] - P0.x, p[1] - P0.y]; }) : [];
    var golfM = U && U.nyr ? Math.max(VEFUR, BIL_HLUTFALL * (U.cap1 || 0)) : (U && U.l1 && U.g && U.g.skorid ? Math.max(VEFUR, BIL_HLUTFALL * U.l1.mm * F[U.l1.id].cap) : VEFUR);
    ["PLATA", "BAK"].forEach(function (hopur) {
      var got = {}, ytra = formPolys(hopEfni(svg, "SKERA-YTRA-" + hopur)), innra = formPolys(hopEfni(svg, "SKERA-INNRA-" + hopur), got);
      if (!ytra.length) return;
      var bb = { x0: 1e9, y0: 1e9, x1: -1e9, y1: -1e9 };
      ytra.forEach(function (pl) { pl.forEach(function (q) { if (q[0] < bb.x0) bb.x0 = q[0]; if (q[0] > bb.x1) bb.x1 = q[0]; if (q[1] < bb.y0) bb.y0 = q[1]; if (q[1] > bb.y1) bb.y1 = q[1]; }); });
      var plata = R(bb.x0, bb.y0, bb.x1 - bb.x0, bb.y1 - bb.y0, 0);
      var flokka = (U && U.nyr ? U.g.skorid : kassar.length) && hopur === "PLATA";
      var holur = flokka ? (U.nyr ? flokkaSkra2(innra, got, U, gotU) : flokkaSkra(innra, got, kassar, gotU)) : [{ hopur: "skra", polys: innra }];
      var V = innra.length ? vefur(holur, plata, null, flokka ? { boga: U.l1 ? Math.min(6, 0.25 * U.l1.mm) : 1.5, golfMilli: golfM - SKRA_VIK, mjott: BRU - SKRA_VIK } : null)
        : { min: LEIT, milli: { d: LEIT }, par: null, innri: { d: LEIT }, eyjur: [], ok: true };
      var bilD = V.par ? V.par.d : V.milli.d;
      var ok = flokka ? (V.milli.d >= VEFUR - SKRA_VIK && (!V.par || V.par.d >= golfM - SKRA_VIK) && V.innri.d >= BRU - SKRA_VIK && !V.eyjur.length)
        : (Math.min(V.milli.d, V.innri.d) >= VEFUR - SKRA_VIK && !V.eyjur.length);
      /* 1.2.0: sams\u00ed\u00f0a fingur (efni milli gaffaltinda) l\u00edka m\u00e6ldir \u00e1 skr\u00e1nni sj\u00e1lfri, n\u00fdja lei\u00f0in */
      if (ok && flokka && U.nyr) { var Fm = fingurMin(holur); if (Fm && Fm.d < BRU - SKRA_VIK) ok = false; }
      ut.stykki.push({ hopur: hopur, min: V.min, milli: V.milli.d, bil: bilD, innri: V.innri.d, eyjur: V.eyjur.length, ok: ok, flokkur: V.flokkur, skurdir: innra.length });
      if (!ok) ut.ok = false;
    });
    if (!ut.stykki.length) ut.ok = false;
    return ut;
  }

  /* ================================================================ SMHerb 1.2.0 (2026-09-29)
     T\u00e1kn, skorinn texti undir, l\u00edna \u00e1 milli og br\u00fdr >= 1,3 mm.
     Eigandinn 2026-09-28/29: t\u00e1kn \u00far ISO 7001 pakkanum hans, \u00e1n aukagjalds. \u00c1 skornum skiltum (hnota, akr\u00fdl,
     \u00e1n baks) er allt skori\u00f0: t\u00e1kn, a\u00f0altexti, l\u00edna og texti undir. \u00c1 tv\u00edlitu er t\u00e1kni\u00f0 grafi\u00f0 og l\u00ednan grafin.
     Eigandinn vill br\u00fdrnar a\u00f0eins brei\u00f0ari: hver br\u00fa \u00e1 skornu skilti er minnst BRU (1,3 mm). Br\u00fdr \u00ed st\u00f6fum Rounded
     Elegance Open og \u00ed t\u00e1knum sem eru mj\u00f3rri eru breikka\u00f0ar (BRU_MARK), a\u00f0rar eru ekki snertar, svo st\u00f3rar t\u00f6lur og
     eldri h\u00f6nnun breytast ekki. Eyjur t\u00e1knanna f\u00e1 br\u00fdr sem eru BRU_EYJA brei\u00f0ar. Bil undir 3 mm milli skur\u00f0a eru
     aldrei loku\u00f0 sj\u00e1lfkrafa: t\u00e1kn me\u00f0 sl\u00edkum bilum bj\u00f3\u00f0ast a\u00f0eins grafin.
     Eldri lei\u00f0in (uppsetning h\u00e9r fyrir ofan) er \u00f3breytt fyrir h\u00f6nnun \u00e1n t\u00e1kns, l\u00ednu og skorins texta undir;
     n\u00fdja lei\u00f0in (uppsetning2) tekur vi\u00f0 hinu. */
  var UTGAFA2 = "1.3.1";
  var BRU = 1.3;          /* minnsta br\u00fa \u00e1 skornu skilti, mm (eigandinn 2026-09-29, talan er m\u00edn) */
  var BRU_MARK = 1.35;    /* mj\u00f3rri br\u00fdr eru breikka\u00f0ar \u00ed \u00feetta, sm\u00e1 bor\u00f0 fyrir m\u00e6linguna \u00e1 skr\u00e1nni */
  var BRU_EYJA = 1.4;     /* br\u00fdr sem halda eyjum t\u00e1knanna */
  var BRU_HRA = 0.9;      /* br\u00fdr mj\u00f3rri en \u00feetta eru ekki breikka\u00f0ar (v\u00e9lin hafnar \u00feeim \u00e1\u00f0ur, MJOTT) */
  var LINA_SK = 1.2;      /* skorin l\u00edna (rauf), mm, eins og \u00e1 myndunum sem eigandinn s\u00e1 */
  var LINA_GR = 0.5;      /* grafin l\u00edna \u00e1 tv\u00edlitu, mm */
  var MIN_TAKN_GR = 30;   /* minnsta grafna t\u00e1kn, mm (lengri hli\u00f0) */
  var SKRA_BORD = 0.02;   /* efni milli skur\u00f0a m\u00e6lt >= 3,02 mm, svo 0,01 mm n\u00e1mundun skr\u00e1rinnar fari aldrei undir 3,0 */
  var CSC = 1e4;

  /* ---------------------------------------------------------------- Clipper */
  function cP(pl) { var o = [], i; for (i = 0; i < pl.length; i++) o.push({ X: Math.round(pl[i][0] * CSC), Y: Math.round(pl[i][1] * CSC) }); return o; }
  function fP(pa) { var o = [], i; for (i = 0; i < pa.length; i++) o.push([pa[i].X / CSC, pa[i].Y / CSC]); return o; }
  function cTre(subj, clip, munur) {
    var CL = W.ClipperLib, c = new CL.Clipper(), tree = new CL.PolyTree();
    c.AddPaths(subj.map(cP), CL.PolyType.ptSubject, true);
    if (clip && clip.length) c.AddPaths(clip.map(cP), CL.PolyType.ptClip, true);
    c.Execute(munur ? CL.ClipType.ctDifference : CL.ClipType.ctUnion, tree, CL.PolyFillType.pftNonZero, CL.PolyFillType.pftNonZero);
    return tree;
  }
  /* allir ytri ferlar tr\u00e9sins (l\u00edka \u00feeir sem sitja inni \u00ed holum) me\u00f0 s\u00ednum holum */
  function hlutarAf(tree) {
    var ut = [];
    (function ganga(n) {
      n.Childs().forEach(function (ch) {
        if (!ch.IsHole()) {
          var h = [];
          ch.Childs().forEach(function (x) { if (x.IsHole()) { var q = fP(x.Contour()); if (q.length > 2) h.push(q); } });
          var y = fP(ch.Contour());
          if (y.length > 2) ut.push({ ytri: y, holur: h });
        }
        ganga(ch);
      });
    })(tree);
    return ut;
  }
  /* allir ferlar me\u00f0 stefnu Clipper (holur \u00f6fugar), fyrir nonzero fyllingu */
  function ferlarAf(tree) {
    var ut = [];
    (function ganga(n) { n.Childs().forEach(function (ch) { var p = fP(ch.Contour()); if (p.length > 2) ut.push({ p: p, hola: ch.IsHole() }); ganga(ch); }); })(tree);
    return ut;
  }
  function flatarmal(pl) { var a = 0, i, j; for (i = 0, j = pl.length - 1; i < pl.length; j = i++) a += (pl[j][0] + pl[i][0]) * (pl[j][1] - pl[i][1]); return a / 2; }
  function hringur(c, r, n) { n = n || 20; var k = r / Math.cos(Math.PI / n), p = [], i; for (i = 0; i < n; i++) p.push([c[0] + k * Math.cos(2 * Math.PI * i / n), c[1] + k * Math.sin(2 * Math.PI * i / n)]); return p; }
  function kassiAf(polys) {
    var b = { x0: 1e9, y0: 1e9, x1: -1e9, y1: -1e9 };
    polys.forEach(function (pl) { pl.forEach(function (q) { if (q[0] < b.x0) b.x0 = q[0]; if (q[0] > b.x1) b.x1 = q[0]; if (q[1] < b.y0) b.y0 = q[1]; if (q[1] > b.y1) b.y1 = q[1]; }); });
    return b;
  }
  function hlidra(polys, dx, dy) { return polys.map(function (pl) { return pl.map(function (q) { return [q[0] + dx, q[1] + dy]; }); }); }
  function polysD(polys, dx, dy) {
    dx = dx || 0; dy = dy || 0;
    return polys.map(function (pl) { return "M" + pl.map(function (q) { return f2(q[0] + dx) + " " + f2(q[1] + dy); }).join("L") + "Z"; }).join("");
  }
  /* punktur sem er \u00f6rugglega inni \u00ed marghyrningnum: mi\u00f0ja brei\u00f0asta bilsins \u00e1 l\u00e1r\u00e9ttri l\u00ednu um mi\u00f0juna */
  function innriPunktur(pl) {
    var b = kassiAf([pl]), y = (b.y0 + b.y1) / 2 + 1e-7 * (b.y1 - b.y0 + 1), xs = [], i, j, n = pl.length;
    for (i = 0, j = n - 1; i < n; j = i++) {
      var a = pl[j], c = pl[i];
      if ((a[1] > y) !== (c[1] > y)) xs.push(a[0] + (y - a[1]) * (c[0] - a[0]) / (c[1] - a[1]));
    }
    xs.sort(function (p, q) { return p - q; });
    var best = null, bw = -1;
    for (i = 0; i + 1 < xs.length; i += 2) if (xs[i + 1] - xs[i] > bw) { bw = xs[i + 1] - xs[i]; best = [(xs[i] + xs[i + 1]) / 2, y]; }
    if (best) return best;
    var cx = 0, cy = 0; pl.forEach(function (q) { cx += q[0]; cy += q[1]; });
    return [cx / n, cy / n];
  }
  function naestAFerli(p, pts) {
    var bd = 1e18, bq = null, i, n = pts.length;
    for (i = 0; i < n; i++) {
      var a = pts[i], b = pts[(i + 1) % n], dx = b[0] - a[0], dy = b[1] - a[1], ll = dx * dx + dy * dy, u = ll ? ((p[0] - a[0]) * dx + (p[1] - a[1]) * dy) / ll : 0;
      if (u < 0) u = 0; else if (u > 1) u = 1;
      var qx = a[0] + u * dx, qy = a[1] + u * dy, d2 = (p[0] - qx) * (p[0] - qx) + (p[1] - qy) * (p[1] - qy);
      if (d2 < bd) { bd = d2; bq = [qx, qy]; }
    }
    return { d: Math.sqrt(bd), q: bq };
  }

  /* ---------------------------------------------------------------- breikkun br\u00faa
     ferlar: einn h\u00f3pur skur\u00f0a (einn stafur, einn hluti t\u00e1kns), mm. Finnur alla sta\u00f0i \u00fear sem efni\u00f0 milli tveggja
     hli\u00f0a skur\u00f0arins er mj\u00f3rra en BRU (br\u00fa, r\u00f6nd undir kommu, bil milli gaffaltinda) og tekur (mark - d) / 2 af
     skur\u00f0inum hvorum megin, sem hringi um b\u00e1\u00f0a endapunkta. Br\u00fain ver\u00f0ur \u00fe\u00e1 mark brei\u00f0; br\u00fdr sem eru BRU e\u00f0a
     brei\u00f0ari eru ekki snertar. Skilar null ef engin br\u00fa er mj\u00f3rri en BRU.
     Sams\u00ed\u00f0a fingur (efni milli gaffaltinda) eru breikka\u00f0ir alveg \u00fat a\u00f0 \u00e1vala endanum.
     maela: breytir engu, skilar mj\u00f3stu br\u00fanni undir BRU + 0,3 mm ({ d, p, q }) e\u00f0a null; m\u00e6lir endanlegt form. */
  var BR_BIL = 0.08;
  function breikka(ferlar0, boga, mark, maela) {
    mark = mark || BRU_MARK;
    var minst = null;
    var F0 = ferlarAf(cTre(ferlar0)), P = [];
    /* ferlarnir sj\u00e1lfir (upprunalegir punktar) \u00ed hnitaneti; lengd eftir ferlinum a\u00f0 hverjum punkti */
    F0.forEach(function (f) {
      var pts = f.p, n = pts.length, cum = [0], L = 0, k;
      for (k = 1; k <= n; k++) { var a = pts[k - 1], b = pts[k % n]; L += Math.sqrt((b[0] - a[0]) * (b[0] - a[0]) + (b[1] - a[1]) * (b[1] - a[1])); cum.push(L); }
      P.push({ pts: pts, cum: cum, L: L, hola: f.hola });
    });
    var CELL = 1, net = {}, lyk = function (a, b) { return (a + 4096) * 8192 + (b + 4096); };
    P.forEach(function (Q, qi) {
      if (Q.hola) return;
      var n = Q.pts.length, s;
      for (s = 0; s < n; s++) {
        var a = Q.pts[s], b = Q.pts[(s + 1) % n], gx, gy;
        for (gx = Math.floor(Math.min(a[0], b[0]) / CELL); gx <= Math.floor(Math.max(a[0], b[0]) / CELL); gx++)
          for (gy = Math.floor(Math.min(a[1], b[1]) / CELL); gy <= Math.floor(Math.max(a[1], b[1]) / CELL); gy++) { var kk = lyk(gx, gy); (net[kk] = net[kk] || []).push(qi * 1e6 + s); }
      }
    });
    /* n\u00e6sti punktur hinum megin vi\u00f0 efni\u00f0 fr\u00e1 p (ferill pi, lengd eftir ferli sp), styttri en takm, e\u00f0a null */
    function naest(p, pi, sp, takm, kp) {
      var bd = takm, bq = null, bpar = false, tp = null, R_ = Math.ceil(takm / CELL), gx = Math.floor(p[0] / CELL), gy = Math.floor(p[1] / CELL), sed = {}, ax, ay, t;
      for (ax = gx - R_; ax <= gx + R_; ax++) for (ay = gy - R_; ay <= gy + R_; ay++) {
        var listi = net[lyk(ax, ay)]; if (!listi) continue;
        for (t = 0; t < listi.length; t++) {
          var code = listi[t]; if (sed[code]) continue; sed[code] = 1;
          var qi = Math.floor(code / 1e6), s = code % 1e6, Q = P[qi], m = Q.pts.length, a = Q.pts[s], b = Q.pts[(s + 1) % m];
          var dx = b[0] - a[0], dy = b[1] - a[1], ll = dx * dx + dy * dy, u = ll ? ((p[0] - a[0]) * dx + (p[1] - a[1]) * dy) / ll : 0;
          if (u < 0) u = 0; else if (u > 1) u = 1;
          var qx = a[0] + u * dx, qy = a[1] + u * dy, d = Math.sqrt((qx - p[0]) * (qx - p[0]) + (qy - p[1]) * (qy - p[1]));
          if (d >= bd || d < 1e-6) continue;
          /* s\u00f6mu skilyr\u00f0i og vefur(): innan sama ferils \u00fearf lei\u00f0in eftir ferlinum a\u00f0 vera l\u00f6ng og mi\u00f0jan \u00ed efninu */
          if (qi === pi) {
            var arc = Math.abs(Q.cum[s] + u * Math.sqrt(ll) - sp); arc = Math.min(arc, Q.L - arc);
            /* 1 mm v\u00e6gara en vefur(): breikka\u00f0a br\u00fanin lengir ferilinn, svo vefur() telur \u00fe\u00e1 a\u00f0eins fleiri p\u00f6r me\u00f0 */
            var samsida = false;
            if (arc <= 4 * d + boga - 1) {
              /* stuttur ferill: telst samt br\u00fa ef hli\u00f0arnar eru sams\u00ed\u00f0a og pari\u00f0 \u00fevert \u00e1 \u00fe\u00e6r (mj\u00f3r fingur alveg \u00fat
                 a\u00f0 \u00e1vala endanum, eins og efni\u00f0 milli gaffaltindanna). Fleygar (M, N, V) og \u00e1valir endar ekki. */
              if (kp == null || arc < 1.4 * d || ll < 1e-12) continue;
              if (!tp) { var P0 = P[pi].pts[kp], P1 = P[pi].pts[(kp + 1) % P[pi].pts.length], tl = Math.sqrt((P1[0] - P0[0]) * (P1[0] - P0[0]) + (P1[1] - P0[1]) * (P1[1] - P0[1])); tp = tl > 1e-12 ? [(P1[0] - P0[0]) / tl, (P1[1] - P0[1]) / tl] : [0, 0]; }
              var sl = Math.sqrt(ll), tq0 = dx / sl, tq1 = dy / sl, vx = (qx - p[0]) / d, vy = (qy - p[1]) / d;
              if (tp[0] * tq0 + tp[1] * tq1 > -0.985 || Math.abs(tp[0] * vx + tp[1] * vy) > 0.2 || Math.abs(tq0 * vx + tq1 * vy) > 0.2) continue;
              samsida = true;
            }
            if (inniI([(p[0] + qx) / 2 + 1.1e-7, (p[1] + qy) / 2 + 1.3e-7], Q.pts)) continue;
            bd = d; bq = [qx, qy]; bpar = samsida; continue;
          }
          bd = d; bq = [qx, qy]; bpar = false;
        }
      }
      return bq ? { d: bd, q: bq, samsida: bpar } : null;
    }
    /* s\u00fdni eftir ferlinum me\u00f0 bili h, [p, lengd] */
    function syni(Q, h, fra, til) {
      var ut = [], n = Q.pts.length, k, j;
      for (k = 0; k < n; k++) {
        var a = Q.pts[k], b = Q.pts[(k + 1) % n], l = Q.cum[k + 1] - Q.cum[k], m = Math.max(1, Math.ceil(l / h));
        if (fra != null && (Q.cum[k + 1] < fra || Q.cum[k] > til)) continue;
        for (j = 0; j < m; j++) { var s = Q.cum[k] + l * j / m; if (fra == null || (s >= fra && s <= til)) ut.push([[a[0] + (b[0] - a[0]) * j / m, a[1] + (b[1] - a[1]) * j / m], s, k]); }
      }
      return ut;
    }
    /* gr\u00f3f leit (0,4 mm) a\u00f0 heitum st\u00f6\u00f0um, f\u00edn (BR_BIL) a\u00f0eins \u00fear */
    var hr = [], GROFT = 0.4;
    P.forEach(function (Q, pi) {
      if (Q.hola) return;
      var heitt = [];
      syni(Q, GROFT, null, null).forEach(function (x) { var r = naest(x[0], pi, x[1], BRU + GROFT + 0.05, x[2]); if (r) heitt.push(x[1]); });
      if (!heitt.length) return;
      var bil = [], i;
      heitt.forEach(function (s) { var a = s - GROFT - 0.1, b = s + GROFT + 0.1; if (bil.length && a <= bil[bil.length - 1][1]) bil[bil.length - 1][1] = b; else bil.push([a, b]); });
      bil.forEach(function (bb) {
        var lst = bb[0] < 0 ? syni(Q, BR_BIL, bb[0] + Q.L, Q.L).concat(syni(Q, BR_BIL, 0, bb[1])) : (bb[1] > Q.L ? syni(Q, BR_BIL, bb[0], Q.L).concat(syni(Q, BR_BIL, 0, bb[1] - Q.L)) : syni(Q, BR_BIL, bb[0], bb[1]));
        for (i = 0; i < lst.length; i++) {
          var r = naest(lst[i][0], pi, lst[i][1], maela ? BRU + 0.3 : mark, lst[i][2]);
          if (maela) { if (r && (!minst || r.d < minst.d)) minst = { d: r.d, p: lst[i][0], q: r.q }; continue; }
          /* hringirnir skarast (s\u00fdnin eru BR_BIL \u00ed sundur), svo br\u00fanin f\u00e6rist alls sta\u00f0ar um minnst (mark - d) / 2 */
          if (r && r.d >= BRU_HRA && r.d < BRU + 0.01) {
            var rr = Math.sqrt(Math.pow((mark - r.d) / 2, 2) + BR_BIL * BR_BIL / 4) + 0.003; hr.push(hringur(lst[i][0], rr), hringur(r.q, rr));
            /* sams\u00ed\u00f0a fingur: hringur um mi\u00f0juna l\u00edka, svo \u00e1vali endinn ver\u00f0ur mark brei\u00f0ur en ekki mj\u00f3r hn\u00fa\u00f0ur */
            if (r.samsida) hr.push(hringur([(lst[i][0][0] + r.q[0]) / 2, (lst[i][0][1] + r.q[1]) / 2], mark / 2 + 0.003, 32));
          }
        }
      });
    });
    if (maela) return minst;
    if (!hr.length) return null;
    return ferlarAf(cTre(F0.map(function (f) { return f.p; }), hr, true)).map(function (f) { return einfalda(f.p, 0.01); });
  }
  /* Ramer-Douglas-Peucker \u00e1 loku\u00f0um ferli (hringirnir skilja eftir \u00fe\u00e9tta punkta \u00e1 breikku\u00f0u br\u00faninni) */
  function einfalda(pl, tol) {
    var n = pl.length; if (n < 8) return pl;
    var far = 0, fd = -1, i;
    for (i = 1; i < n; i++) { var dx = pl[i][0] - pl[0][0], dy = pl[i][1] - pl[0][1], d = dx * dx + dy * dy; if (d > fd) { fd = d; far = i; } }
    var halda = []; for (i = 0; i < n; i++) halda.push(false);
    halda[0] = halda[far] = true;
    var stafli = [[0, far], [far, n]];
    while (stafli.length) {
      var b = stafli.pop(), a0 = b[0], a1 = b[1], A = pl[a0], B = pl[a1 % n], ex = B[0] - A[0], ey = B[1] - A[1], el = Math.sqrt(ex * ex + ey * ey), md = -1, mi = -1;
      for (i = a0 + 1; i < a1; i++) {
        var P = pl[i], d2 = el > 1e-12 ? Math.abs((P[0] - A[0]) * ey - (P[1] - A[1]) * ex) / el : Math.sqrt((P[0] - A[0]) * (P[0] - A[0]) + (P[1] - A[1]) * (P[1] - A[1]));
        if (d2 > md) { md = d2; mi = i; }
      }
      if (md > tol) { halda[mi] = true; stafli.push([a0, mi], [mi, a1]); }
    }
    var ut = []; for (i = 0; i < n; i++) if (halda[i]) ut.push(pl[i]);
    return ut.length > 2 ? ut : pl;
  }
  var BRC = {};
  function breikkaStaf(L, g, mm) {
    var key = L.id + "|" + g + "|" + mm.toFixed(5);
    if (BRC.hasOwnProperty(key)) return BRC[key];
    var S = stafur(L, g), c = L.font.glyphs.get(g).unicode != null ? String.fromCharCode(L.font.glyphs.get(g).unicode) : "", e = L.id === LETUR.reo ? BRYR_HERB[c] : null;
    if (!S.p.length || (e && e * mm >= BRU + 0.1)) return (BRC[key] = null);
    var polys = S.p.map(function (pl) { return pl.map(function (q) { return [q[0] * mm, q[1] * mm]; }); });
    return (BRC[key] = breikka(polys, Math.min(6, 0.25 * mm)));
  }
  /* breikkar mj\u00f3u br\u00fdrnar \u00ed skornum st\u00f6fum l\u00ednunnar; Ln.breikkad = { i: ferlar (mm, mi\u00f0a\u00f0 vi\u00f0 stafinn) } e\u00f0a null */
  function breikkaLinu(Ln) {
    var L = F[Ln.id], n = 0;
    Ln.breikkad = {};
    Ln.gl.forEach(function (g, i) { if (g.bil || !g.g) return; var b = breikkaStaf(L, g.g, Ln.mm); if (b) { Ln.breikkad[i] = b; n++; } });
    if (!n) Ln.breikkad = null;
    return n;
  }
  function linuPolysX(Ln, forsk, hra) {
    var L = F[Ln.id], ut = [];
    Ln.gl.forEach(function (g, i) {
      if (g.bil || !g.g) return;
      var ox = Ln.stafir[i], oy = Ln.y, b = !hra && Ln.breikkad && Ln.breikkad[i], polys;
      if (b) polys = hlidra(b, ox, oy);
      else { var S = stafur(L, g.g), mm = Ln.mm; polys = S.p.map(function (pl) { return pl.map(function (q) { return [ox + q[0] * mm, oy + q[1] * mm]; }); }); }
      ut.push({ hopur: (forsk || "s") + i, stafur: g.c, boga: Math.min(6, 0.25 * Ln.mm), polys: polys });
    });
    return ut;
  }
  /* SVG d l\u00ednunnar: upprunalegir ferlar, en breikka\u00f0ir stafir sem marghyrningar */
  function linuDX(Ln, dx, dy) {
    if (!Ln.stafir) return "";
    if (!Ln.breikkad) return linuD(Ln, dx, dy);
    var L = F[Ln.id], s = "";
    dx = dx || 0; dy = dy || 0;
    Ln.gl.forEach(function (g, i) {
      if (g.bil || !g.g) return;
      var b = Ln.breikkad[i];
      if (b) { s += polysD(b, Ln.stafir[i] + dx, Ln.y + dy); return; }
      var S = stafur(L, g.g), ox = Ln.stafir[i] + dx, oy = Ln.y + dy, mm = Ln.mm;
      var X = function (v) { return f2(ox + v * mm); }, Y = function (v) { return f2(oy + v * mm); };
      S.c.forEach(function (k) {
        if (k.t === "Z") s += "Z";
        else if (k.t === "C") s += "C" + X(k.x1) + " " + Y(k.y1) + " " + X(k.x2) + " " + Y(k.y2) + " " + X(k.x) + " " + Y(k.y);
        else if (k.t === "Q") s += "Q" + X(k.x1) + " " + Y(k.y1) + " " + X(k.x) + " " + Y(k.y);
        else s += k.t + X(k.x) + " " + Y(k.y);
      });
    });
    return s;
  }
  /* l\u00edna \u00ed framlei\u00f0sluskr\u00e1na: texti (SMFram teiknar letri\u00f0) e\u00f0a sl\u00f3\u00f0 \u00feegar br\u00fdr voru breikka\u00f0ar */
  function linuHlutur(Ln, lag, dx, dy) {
    if (Ln.breikkad) return { gerd: "slod", lag: lag, hopur: "PLATA", d: linuDX(Ln, dx, dy), texti_: Ln.gl.map(function (x) { return x.c; }).join(""), letur: Ln.id, mm: +Ln.mm.toFixed(4) };
    return { gerd: "texti", lag: lag, hopur: "PLATA", texti: Ln.gl.map(function (x) { return x.c; }).join(""), letur: Ln.id, mm: +Ln.mm.toFixed(4), x: 0, y: +(Ln.y + dy).toFixed(4),
      stafir: Ln.stafir.map(function (v) { return +(v + dx).toFixed(4); }), bandstafir: false, kerning: false };
  }

  /* ---------------------------------------------------------------- t\u00e1kn (ISO 7001, pakki eigandans)
     assets/sm-herbergi-takn.json: { v, takn: [{ k: k\u00f3\u00f0i, n: heiti, d: sl\u00f3\u00f0 \u00ed einingum (lengri hli\u00f0 = 1, y ni\u00f0ur),
     w, h: st\u00e6r\u00f0 \u00ed einingum, gr: minnsta grafi\u00f0 (mm), sk: minnsta skori\u00f0 (mm) e\u00f0a null }] }. sk er reikna\u00f0 me\u00f0
     \u00feessari v\u00e9l (src/takn_gogn.cjs): br\u00fdr \u00e1 eyjum, breikka\u00f0ar br\u00fdr, 3,0 mm milli a\u00f0skilinna skur\u00f0a. */
  var TK = {}, TK_ROD = [], tkBid = null;
  function skraTakn(j) {
    ((j && j.takn) || []).forEach(function (t) {
      if (!t || !t.k || TK[t.k]) return;
      TK[t.k] = { kodi: t.k, heiti: t.n, birting: t.b || t.n, d: t.d, w: t.w, h: t.h, gr: t.gr || MIN_TAKN_GR, sk: t.sk || null, c: null, p: null };
      TK_ROD.push(t.k);
    });
    return TK_ROD;
  }
  function hladaTakn(url) {
    if (TK_ROD.length) return Promise.resolve(TK_ROD);
    if (tkBid) return tkBid;
    if (!url) return Promise.reject(new Error("SMHerb: engin sl\u00f3\u00f0 fyrir t\u00e1kn"));
    tkBid = fetch(url, { credentials: "same-origin" }).then(function (r) {
      if (!r.ok) throw new Error("SMHerb: " + r.status + " t\u00e1kn");
      return r.json();
    }).then(skraTakn);
    tkBid["catch"](function () { tkBid = null; });
    return tkBid;
  }
  function taknCmds(T) { return T.c || (T.c = lesaD(T.d)); }
  function taknEining(T) { return T.p || (T.p = flatten(taknCmds(T), 0.00016)); }
  function taknHrar(T, S, x, y) { x = x || 0; y = y || 0; return taknEining(T).map(function (pl) { return pl.map(function (q) { return [x + q[0] * S, y + q[1] * S]; }); }); }
  /* grafi\u00f0 t\u00e1kn: upprunalegir ferlar */
  function taknD(T, S, x, y) {
    var s = "", X = function (v) { return f2(x + v * S); }, Y = function (v) { return f2(y + v * S); };
    taknCmds(T).forEach(function (k) {
      if (k.t === "Z") s += "Z";
      else if (k.t === "C") s += "C" + X(k.x1) + " " + Y(k.y1) + " " + X(k.x2) + " " + Y(k.y2) + " " + X(k.x) + " " + Y(k.y);
      else if (k.t === "Q") s += "Q" + X(k.x1) + " " + Y(k.y1) + " " + X(k.x) + " " + Y(k.y);
      else s += k.t + X(k.x) + " " + Y(k.y);
    });
    return s;
  }
  /* Br\u00fdr \u00e1 eyju (loku\u00f0 plata inni \u00ed t\u00e1kni): tv\u00e6r BRU_EYJA br\u00fdr \u00fevert yfir skur\u00f0inn \u00e1 stystu lei\u00f0 \u00fat \u00ed pl\u00f6tuna,
     s\u00fa seinni minnst h\u00e1lfa lengd eyjunnar fr\u00e1 \u00feeirri fyrri. Br\u00fain \u00fearf a\u00f0 skera skur\u00f0inn hreint \u00ed sundur. */
  function bruaEyju(K, hola) {
    var inniBlek = function (p) {
      if (!inniI(p, K.ytri)) return false;
      for (var i = 0; i < K.holur.length; i++) if (inniI(p, K.holur[i])) return false;
      return true;
    };
    var bb = kassiAf([hola]), B = BRU_EYJA, kand = [];
    thetta(hola, 0.2).forEach(function (p) {
      var n = naestAFerli(p, K.ytri), L = n.d, q = n.q, ok = L > 1e-6, s2, j, e;
      for (s2 = 0.1; ok && s2 < L; s2 += 0.1) { var t = s2 / L; if (!inniBlek([p[0] + (q[0] - p[0]) * t, p[1] + (q[1] - p[1]) * t])) ok = false; }
      if (ok) {
        var u = [(q[0] - p[0]) / L, (q[1] - p[1]) / L], nv = [-u[1], u[0]], hl = [-B / 2, 0, B / 2];
        for (j = 0; j < 3 && ok; j++) for (e = 0; e < 2 && ok; e++) {
          var z = e ? q : p, f = e ? 0.3 : -0.3;
          if (inniBlek([z[0] + u[0] * f + nv[0] * hl[j], z[1] + u[1] * f + nv[1] * hl[j]])) ok = false;
        }
      }
      if (ok) kand.push({ p: p, q: q, d: L });
    });
    kand.sort(function (a, b) { return a.d - b.d; });
    if (!kand.length) return null;
    var b1 = kand[0], fj = 0.5 * Math.max(bb.x1 - bb.x0, bb.y1 - bb.y0), b2 = null, i;
    for (i = 1; i < kand.length; i++) { var k = kand[i]; if (Math.sqrt((k.p[0] - b1.p[0]) * (k.p[0] - b1.p[0]) + (k.p[1] - b1.p[1]) * (k.p[1] - b1.p[1])) >= fj) { b2 = k; break; } }
    return [b1, b2].filter(Boolean).map(function (b) {
      var L = b.d, u = [(b.q[0] - b.p[0]) / L, (b.q[1] - b.p[1]) / L], nv = [-u[1] * B / 2, u[0] * B / 2], e = 0.3;
      var a0 = [b.p[0] - u[0] * e, b.p[1] - u[1] * e], a1 = [b.q[0] + u[0] * e, b.q[1] + u[1] * e];
      return [[a0[0] + nv[0], a0[1] + nv[1]], [a1[0] + nv[0], a1[1] + nv[1]], [a1[0] - nv[0], a1[1] - nv[1]], [a0[0] - nv[0], a0[1] - nv[1]]];
    });
  }
  /* Skur\u00f0ar\u00fatg\u00e1fa t\u00e1kns \u00ed st\u00e6r\u00f0 S (lengri hli\u00f0, mm), efra vinstra horn \u00ed (0, 0): br\u00fdr \u00e1 eyjum, breikka\u00f0ar br\u00fdr,
     h\u00f3par fyrir vefinn (hver upprunalegur hluti t\u00e1kns er einn h\u00f3pur: 3,0 mm milli hluta, BRU innan hluta). */
  var TSK = {};
  function taknSkurdur(T, S) {
    var key = T.kodi + "|" + S;
    if (TSK[key]) return TSK[key];
    var hrar = taknHrar(T, S), K = hlutarAf(cTre(hrar)), bryr = [], vandi = false;
    K.forEach(function (k) { k.holur.forEach(function (h) { if (Math.abs(flatarmal(h)) < 0.01) return; var b = bruaEyju(k, h); if (!b) vandi = true; else bryr = bryr.concat(b); }); });
    var heilt = K.map(function (k) { return k.ytri; }).concat([].concat.apply([], K.map(function (k) { return k.holur; })));
    var hlutar = hlutarAf(bryr.length ? cTre(heilt, bryr, true) : cTre(heilt));
    var hop = K.map(function (k, i) { return { hopur: "t" + i, stafur: T.kodi, boga: 1.5, polys: [] }; });
    hlutar.forEach(function (h) {
      var ip = innriPunktur(h.ytri), best = -1, i, j;
      for (i = 0; i < K.length && best < 0; i++) {
        if (!inniI(ip, K[i].ytri)) continue;
        var iHolu = false; for (j = 0; j < K[i].holur.length; j++) if (inniI(ip, K[i].holur[j])) iHolu = true;
        if (!iHolu) best = i;
      }
      if (best < 0) best = 0;
      hop[best].polys.push(h.ytri);
      h.holur.forEach(function (x) { hop[best].polys.push(x); });
    });
    var nBr = 0;
    hop.forEach(function (h) { if (!h.polys.length) return; var b = breikka(h.polys, 1.5); if (b) { h.polys = b; nBr++; } });
    hop = hop.filter(function (h) { return h.polys.length; });
    return (TSK[key] = { hopar: hop, K: K, bryr: bryr.length, breikkad: nBr, vandi: vandi, S: S, w: T.w * S, h: T.h * S });
  }
  /* mj\u00f3sta br\u00fa e\u00f0a fingur (sams\u00ed\u00f0a hli\u00f0ar) \u00ed h\u00f3pum skur\u00f0a \u00e1 endanlegu formi, e\u00f0a null ef allt er vel breitt */
  function fingurMin(hopar) {
    var m = null;
    hopar.forEach(function (h) { if (h.gat || !h.polys.length) return; var x = breikka(h.polys, h.boga != null ? h.boga : 1.5, null, true); if (x && (!m || x.d < m.d)) m = x; });
    return m;
  }
  /* T\u00e1kni\u00f0 eitt og s\u00e9r \u00e1 st\u00f3rri pl\u00f6tu: stenst \u00fea\u00f0 skur\u00f0arreglurnar \u00ed st\u00e6r\u00f0 S? (src/takn_gogn.cjs og pr\u00f3fanir) */
  /* m\u00e6ling t\u00e1kns \u00e1 endanlegu formi, einu sinni fyrir hverja st\u00e6r\u00f0 */
  function taknFingur(sk) { if (sk.fingur === undefined) sk.fingur = fingurMin(sk.hopar); return sk.fingur; }
  /* m\u00e6ling stafs (breikka\u00f0ur ef \u00feurfti), einu sinni fyrir hvern staf og st\u00e6r\u00f0; \u00f3h\u00e1\u00f0 sta\u00f0 \u00ed l\u00ednunni */
  var FGC = {};
  function stafFingur(L, g, mm) {
    var key = L.id + "|" + g + "|" + mm.toFixed(5);
    if (FGC.hasOwnProperty(key)) return FGC[key];
    var b = breikkaStaf(L, g, mm), S = stafur(L, g);
    var polys = b || S.p.map(function (pl) { return pl.map(function (q) { return [q[0] * mm, q[1] * mm]; }); });
    return (FGC[key] = polys.length ? breikka(polys, Math.min(6, 0.25 * mm), null, true) : null);
  }
  function linuFingur(Ln) {
    var m = null, L = Ln && F[Ln.id];
    if (!Ln) return null;
    Ln.gl.forEach(function (g) { if (g.bil || !g.g) return; var x = stafFingur(L, g.g, Ln.mm); if (x && (!m || x.d < m.d)) m = x; });
    return m;
  }
  function taknStenst(T, S) {
    var r = taknSkurdur(T, S);
    r.fingur = taknFingur(r);
    if (r.vandi) return { ok: false, vandi: "eyja", r: r };
    var V = vefur(r.hopar, R(-50, -50, S + 100, S + 100, 0), null, { boga: 1.5, mjott: BRU });
    return { ok: V.ok && !(r.fingur && r.fingur.d < BRU - 0.005), V: V, r: r, fingur: r.fingur };
  }

  /* ---------------------------------------------------------------- n\u00fdja uppsetningin */
  function haedStafa(t, id) {
    /* BRYR_HERB er maeld a Rounded Elegance Open; SM Didot bryr (0,081 em) er maelt a raunverulegu formi (vefur, MJOTT/BRU) */
    if (id && id !== LETUR.reo) return { h: 0, c: "" };
    var h = 0, c = "", cap = F[LETUR.reo].cap;
    t.split("").forEach(function (ch) { var e = BRYR_HERB[ch]; if (e && MJOTT / e * cap > h) { h = MJOTT / e * cap; c = ch; } });
    return { h: h, c: c };
  }
  /* skorin l\u00edna: stafabili\u00f0 breikkar \u00fear til bil milli stafa >= golf; letri\u00f0 minnkar ef breiddin bindur */
  var LSK = {};
  function linaSkorin(t, cap, maxW, golf, id) {
    id = id || LETUR.reo;
    var L = F[id], key = (id === LETUR.reo ? "" : id + "|") + t + "|" + cap.toFixed(3) + "|" + maxW.toFixed(2) + "|" + golf.toFixed(3), k = LSK[key];
    if (k) { var L0 = lina(id, t, k.mm, k.sb); L0.bilOk = k.ok; return L0; }
    var sb = SB0, mm = cap / L.cap, Ln, it, ok = true;
    for (it = 0; it < 30; it++) {
      Ln = lina(id, t, mm, sb);
      var w = Ln.blek.x1 - Ln.blek.x0;
      if (w > maxW) { mm *= maxW / w * 0.999; Ln = lina(id, t, mm, sb); }
      if (t.replace(/\s+/g, "").length < 2) break;
      stadsetja(Ln, 0, 0);
      var bm = bilStafa(Ln);
      if (bm >= golf - 1e-9) break;
      var mmN = Ln.mm, gEm = bm / mmN, w1 = (Ln.blek.x1 - Ln.blek.x0) / mmN, nb = Math.max(1, t.length - 1), mk = golf + 0.1;
      var bundid = Math.abs(mmN * w1 - maxW) < 0.05 * maxW, nefn = maxW - mk * nb;
      var dsb = bundid && nefn > 0 ? (mk * w1 - gEm * maxW) / nefn : (mk / mmN - gEm);
      var nsb = sb + Math.max(0.005, dsb);
      if (nsb > SB_MAX) { ok = false; break; }
      sb = nsb;
    }
    LSK[key] = { mm: Ln.mm, sb: Ln.stafabil, ok: ok };
    Ln.bilOk = ok;
    return Ln;
  }
  /* minnsta bil milli n\u00e1grannastafa \u00ed l\u00ednu (mm): punktar hvors stafs vi\u00f0 hli\u00f0ar hins, a\u00f0eins \u00fear sem \u00feeir m\u00e6tast */
  function bilStafa(Ln) {
    var hop = linuPolys(Ln), best = 1e9, i, j;
    var kassi = hop.map(function (h) { return kassiAf(h.polys); });
    var fjarl = function (A, B, x0, x1) {
      var m = 1e9;
      A.forEach(function (pa) { pa.forEach(function (p) {
        if (p[0] < x0 || p[0] > x1) return;
        B.forEach(function (pb) { var n = pb.length, k; for (k = 0; k < n; k++) {
          var a = pb[k], b = pb[(k + 1) % n], dx = b[0] - a[0], dy = b[1] - a[1], ll = dx * dx + dy * dy, u = ll ? ((p[0] - a[0]) * dx + (p[1] - a[1]) * dy) / ll : 0;
          if (u < 0) u = 0; else if (u > 1) u = 1;
          var qx = a[0] + u * dx - p[0], qy = a[1] + u * dy - p[1], d2 = qx * qx + qy * qy; if (d2 < m) m = d2;
        } });
      }); });
      return Math.sqrt(m);
    };
    for (i = 0; i < hop.length; i++) for (j = i + 1; j < hop.length && j <= i + 2; j++) {
      var a = kassi[i], b = kassi[j], L = 6;
      if (b.x0 - a.x1 > L) continue;
      var d = Math.min(fjarl(hop[i].polys, hop[j].polys, b.x0 - L, 1e9), fjarl(hop[j].polys, hop[i].polys, -1e9, a.x1 + L));
      if (d < best) best = d;
    }
    return best;
  }
  function linaGrafin(id, t, cap, maxW, sb) {
    var L = F[id], mm = cap / L.cap, Ln = lina(id, t, mm, sb), w = Ln.blek.x1 - Ln.blek.x0;
    if (w > maxW) Ln = lina(id, t, mm * maxW / w * 0.999, sb);
    return Ln;
  }
  function stadsetjaV(Ln, x, y0) {
    Ln.x0 = x - Ln.blek.x0; Ln.y = y0 - Ln.blek.y0;
    Ln.stafir = Ln.gl.map(function (g) { return Ln.x0 + g.x; });
    Ln.kassi = { x: Ln.x0 + Ln.blek.x0, y: Ln.y + Ln.blek.y0, w: Ln.blek.x1 - Ln.blek.x0, h: Ln.blek.y1 - Ln.blek.y0 };
    return Ln;
  }
  /* l\u00edna me\u00f0 h\u00e1lfhringlaga endum, efri br\u00fan \u00ed y */
  function strik(x, y, w, t) {
    var r = t / 2, p = [], n = 12, k;
    for (k = 0; k <= n; k++) { var a = -Math.PI / 2 + Math.PI * k / n; p.push([x + w - r + r * Math.cos(a), y + r + r * Math.sin(a)]); }
    for (k = 0; k <= n; k++) { var b = Math.PI / 2 + Math.PI * k / n; p.push([x + r + r * Math.cos(b), y + r + r * Math.sin(b)]); }
    return p;
  }
  function breiddL(Ln) { return Ln ? Ln.blek.x1 - Ln.blek.x0 : 0; }
  function haedL(Ln) { return Ln ? Ln.blek.y1 - Ln.blek.y0 : 0; }

  function uppsetning2(s, o, g, U) {
    o = o || {};
    U.nyr = true;
    var t1 = hreinsa(s.texti || ""), t2 = hreinsa(s.undir || "");
    var sk = g.skorid, id1 = leturAf(s, sk), id2 = id1;
    if (hastafir(id1)) { t1 = upp(t1); t2 = upp(t2); }
    U.texti = t1; U.undir = t2;
    if (!F[id1] || (s.takn && !TK_ROD.length)) { U.villur.push({ kodi: "hledst" }); return U; }
    var T = s.takn ? TK[s.takn] : null;
    if (s.takn && !T) { U.villur.push({ kodi: "takn_ogilt", takn: s.takn }); return U; }
    if (!t1 && !T) { U.villur.push({ kodi: "vantar_texti" }); return U; }
    if (!t1 && t2) { U.villur.push({ kodi: "vantar_texti" }); return U; }
    var ogild = [], ogild2 = [];
    t1.split("").forEach(function (c) { if (!LEYFT_AD.test(c) && ogild.indexOf(c) < 0) ogild.push(c); });
    t2.split("").forEach(function (c) { if (!LEYFT_UNDIR.test(c) && ogild2.indexOf(c) < 0) ogild2.push(c); });
    if (ogild.length) U.villur.push({ kodi: "ogilt", reitur: "texti", takn: ogild.join(" ") });
    if (ogild2.length) U.villur.push({ kodi: "ogilt", reitur: "undir", takn: ogild2.join(" ") });
    if (U.villur.length) return U;
    if (T && sk && !T.sk) { U.villur.push({ kodi: "takn_skorid", takn: T.heiti }); return U; }
    var linaA = !!(s.lina && t2 && t1);
    if (T && g.S.b <= 90 && g.S.h <= 90 && t1 && (t2 || linaA)) { U.villur.push({ kodi: "takn_9x9" }); return U; }
    U.takn = T; U.linaA = linaA;
    var stada = T ? (!t1 ? "eitt" : (s.taknStada === "vinstri" ? "vinstri" : "ofan")) : "";
    U.stada = stada;

    /* textasv\u00e6\u00f0i\u00f0 (eins og eldri lei\u00f0in) */
    var base;
    if (sk) base = g.O;
    else if (g.rammi) base = g.rammi;
    else if (g.got.length) base = inn(g.plata, g.e + GAT_R + 2);
    else base = g.plata;
    var m = sk ? Math.max(5, 0.07 * Math.min(base.w, base.h)) : Math.max(3, 0.06 * Math.min(base.w, base.h));
    var Z = inn(base, m);
    if (sk && g.got.length === 2 && g.got[0][0] === g.got[1][0]) {
      var efst = g.got[0][1] + GAT_R + VEFUR + 1.5, nedst = g.got[1][1] - GAT_R - VEFUR - 1.5;
      if (Z.y < efst) { Z.h -= efst - Z.y; Z.y = efst; }
      if (Z.y + Z.h > nedst) Z.h = nedst - Z.y;
    } else if (sk && g.got.length === 2) {
      /* 1.3.1: tv\u00f6 g\u00f6t til hli\u00f0anna (140x90): textinn heldur sig innan vi\u00f0 \u00feau */
      var vinstra = g.got[0][0] + GAT_R + VEFUR + 1.5, haegra = g.got[1][0] - GAT_R - VEFUR - 1.5;
      if (Z.x < vinstra) { Z.w -= vinstra - Z.x; Z.x = vinstra; }
      if (Z.x + Z.w > haegra) Z.w = haegra - Z.x;
    }
    U.Z = Z;
    var cap1Em = F[id1].cap, cap2Em = F[id2].cap, cx = Z.x + Z.w / 2;
    var hs1 = sk && t1 ? haedStafa(t1, id1) : { h: 0, c: "" }, hs2 = sk && t2 ? haedStafa(t2, id2) : { h: 0, c: "" };
    var min1 = t1 ? (sk ? Math.max(MIN_SKORID, hs1.h) : MIN_GRAFA) : 0;
    var min2 = t2 ? (sk ? Math.max(MIN_SKORID, hs2.h) : MIN_UNDIR) : 0;
    var minS = T ? (sk ? T.sk : T.gr) : 0;
    var S0 = 0;
    if (T) {
      if (stada === "eitt") S0 = 0.75 * Math.min(Z.w, Z.h);
      else if (stada === "vinstri") S0 = Math.min(0.66 * Z.h, 0.4 * Z.w);
      else S0 = Math.min(0.39 * Z.h, 0.8 * Z.w);
      S0 = Math.max(S0, minS);
    }
    var tL = linaA ? (sk ? LINA_SK : LINA_GR) : 0;

    function byggja(kv) {
      var r = { S: 0, ti: null, l1: null, l2: null, linaP: null, vandi: "" }, S = 0;
      if (T) {
        S = Math.max(minS, S0 * kv);
        S = sk ? Math.max(Math.ceil(minS * 2) / 2, Math.floor(S * 2) / 2) : Math.round(S * 100) / 100;
      }
      r.S = S;
      var iw = T ? T.w * S : 0, ih = T ? T.h * S : 0, gIT = T ? Math.max(5, 0.17 * S) : 0, gIV = T ? Math.max(6, 0.15 * S) : 0;
      var Wt = Z.w, Ht = Z.h;
      if (stada === "vinstri") Wt = Z.w - iw - gIV;
      else if (stada === "ofan") Ht = Z.h - ih - gIT;
      if (iw > Z.w + 1e-6 || ih > Z.h + 1e-6 || (t1 && (Wt < 5 || Ht < 3))) { r.vandi = "takn"; return r; }
      var cap1 = 0, cap2 = 0;
      if (t1) {
        var c1 = kv * Math.min(Ht * (t2 ? 0.55 : 0.62), s.hamarkH > 0 ? s.hamarkH * g.S.h : 1e9), W1 = s.hamarkB > 0 ? Math.min(Wt, s.hamarkB * g.S.b) : Wt;   /* 14.10: hamark adaltexta */
        r.l1 = sk ? linaSkorin(t1, c1, W1, Math.max(VEFUR + SKRA_BORD, BIL_HLUTFALL * c1), id1) : linaGrafin(id1, t1, c1, W1, 0.02);
        cap1 = r.l1.mm * cap1Em;
        if (sk && r.l1.bilOk === false) { r.vandi = "bil"; return r; }
      }
      if (t2) {
        var c2 = sk ? Math.max(min2, Math.min(0.6 * cap1, cap1)) : Math.min(s.undirHlutfall > 0 ? 14 : 9, Math.max(3.2, (s.undirHlutfall > 0 ? s.undirHlutfall : 0.17) * cap1));
        r.l2 = sk ? linaSkorin(t2, c2, Wt, Math.max(VEFUR + SKRA_BORD, BIL_HLUTFALL * cap1), id2) : linaGrafin(id2, t2, c2, Wt, 0.16);
        cap2 = r.l2.mm * cap2Em;
        if (sk && r.l2.bilOk === false) { r.vandi = "bil2"; return r; }
      }
      r.cap1 = cap1; r.cap2 = cap2;
      if (t1 && cap1 < min1 - 1e-9) { r.vandi = "min1"; return r; }
      if (t2 && cap2 < min2 - 1e-9) { r.vandi = "min2"; return r; }
      if (sk && t2 && cap2 > cap1 + 1e-9) { r.vandi = "min1"; return r; }
      var h1 = haedL(r.l1), h2 = haedL(r.l2), gL = 0, g12 = 0, stafli = h1;
      if (r.l2) {
        if (linaA) { gL = sk ? Math.max(VEFUR + 0.8, 0.22 * cap1) : Math.max(1.6, 0.22 * cap1); stafli = h1 + gL + tL + gL + h2; }
        else { g12 = sk ? Math.max(VEFUR + 1.5, 0.3 * cap1) : 0.3 * cap1; stafli = h1 + g12 + h2; }
      }
      if (t1 && stafli > Ht + 1e-6) { r.vandi = "haed"; return r; }
      var w1 = breiddL(r.l1), w2 = breiddL(r.l2), wMax = Math.max(w1, w2);
      var Lw = linaA ? Math.min(wMax, Math.max(w2 * 1.15, 0.55 * wMax)) : 0;
      var ix = 0, iy = 0, y, xT = 0;
      if (stada === "eitt") { ix = cx - iw / 2; iy = Z.y + (Z.h - ih) / 2; }
      else if (stada === "vinstri") {
        var heild = iw + gIV + wMax; ix = Z.x + (Z.w - heild) / 2; iy = Z.y + (Z.h - ih) / 2; xT = ix + iw + gIV;
        y = Z.y + (Z.h - stafli) / 2;
        stadsetjaV(r.l1, xT, y); y += h1;
        if (r.l2) {
          if (linaA) { y += gL; r.linaP = strik(xT, y, Lw, tL); y += tL + gL; } else y += g12;
          stadsetjaV(r.l2, xT, y);
        }
      } else {
        var heildH = (T ? ih + gIT : 0) + stafli;
        y = Z.y + (Z.h - heildH) / 2;
        if (T) { ix = cx - iw / 2; iy = y; y += ih + gIT; }
        stadsetja(r.l1, cx, y); y += h1;
        if (r.l2) {
          if (linaA) { y += gL; r.linaP = strik(cx - Lw / 2, y, Lw, tL); y += tL + gL; } else y += g12;
          stadsetja(r.l2, cx, y);
        }
      }
      if (T) r.ti = { T: T, S: S, x: ix, y: iy, w: iw, h: ih, sk: sk ? taknSkurdur(T, S) : null };
      return r;
    }
    function holurAf(r, breikkad) {
      var h = [];
      if (r.l1) h = h.concat(linuPolysX(r.l1, "s", !breikkad));
      if (r.l2) h = h.concat(linuPolysX(r.l2, "u", !breikkad));
      if (r.ti) r.ti.sk.hopar.forEach(function (q) { h.push({ hopur: q.hopur, stafur: q.stafur, boga: q.boga, polys: hlidra(q.polys, r.ti.x, r.ti.y) }); });
      if (r.linaP) h.push({ hopur: "l", stafur: "", boga: 1, polys: [r.linaP] });
      g.got.forEach(function (p, i) { h.push({ hopur: "g" + i, gat: true, stafur: "", polys: [hringPoly(p[0], p[1], GAT_R)] }); });
      return h;
    }
    function hettaVandi(r) {
      /* grafi\u00f0 m\u00e1 ekki lenda undir hettu tappans: minnst HETTA_BIL \u00fat fyrir br\u00fan hennar */
      var kassar = [];
      if (r.l1) kassar.push(r.l1.kassi);
      if (r.l2) kassar.push(r.l2.kassi);
      if (r.ti) kassar.push({ x: r.ti.x, y: r.ti.y, w: r.ti.w, h: r.ti.h });
      if (r.linaP) { var b = kassiAf([r.linaP]); kassar.push({ x: b.x0, y: b.y0, w: b.x1 - b.x0, h: b.y1 - b.y0 }); }
      for (var i = 0; i < g.got.length; i++) for (var j = 0; j < kassar.length; j++) {
        var p = g.got[i], k = kassar[j], nx = Math.max(k.x, Math.min(p[0], k.x + k.w)), ny = Math.max(k.y, Math.min(p[1], k.y + k.h));
        if (Math.sqrt((p[0] - nx) * (p[0] - nx) + (p[1] - ny) * (p[1] - ny)) < HETTA_R + HETTA_BIL) return true;
      }
      return false;
    }

    var kv = 1, it, r = null, V = null, sidastaV = null, sidastaR = null, astaeda = "", ok = false, saga = [], vara = null;
    /* t\u00e1kn vinstra megin: ef textinn er bundinn af breiddinni og miklu minni en t\u00e1kni\u00f0, minnkar t\u00e1kni\u00f0 (a\u00f0 l\u00e1gmarki)
       svo textinn f\u00e1i meira pl\u00e1ss; fyrsta gilda \u00fatliti\u00f0 er geymt ef ekkert jafnara finnst */
    function ojafnt(r) { return stada === "vinstri" && r.ti && r.cap1 < 0.3 * r.ti.h && r.S > minS + 0.5 && kv > 0.45; }
    U.saga = saga;
    for (it = 0; it < 26; it++, kv *= 0.94) {
      r = byggja(kv);
      saga.push(r.vandi || "");
      if (r.vandi) {
        astaeda = r.vandi;
        if ((r.vandi === "min1" || r.vandi === "min2" || r.vandi === "bil" || r.vandi === "bil2") && (!T || r.S <= minS + 1e-9)) break;
        if (r.vandi === "takn" && (!T || r.S <= minS + 1e-9)) break;
        continue;
      }
      sidastaR = r;
      if (o.anAthugunar) { ok = true; break; }
      if (sk) {
        /* br\u00fdr undir BRU breikka\u00f0ar fyrst, svo m\u00e6lt \u00e1 endanlegu formi me\u00f0 BRU sem g\u00f3lf */
        if (r.l1) breikkaLinu(r.l1);
        if (r.l2) breikkaLinu(r.l2);
        V = vefur(holurAf(r, true), g.plata, g.bak ? g.O : null, { boga: r.l1 ? Math.min(6, 0.25 * r.l1.mm) : 1.5, golfMilli: Math.max(VEFUR + SKRA_BORD, BIL_HLUTFALL * r.cap1), mjott: BRU });
        sidastaV = V;
        if (V.eyjur.length) { astaeda = "eyja"; break; }
        /* fingur og br\u00fdr m\u00e6ld \u00e1 endanlegu formi l\u00edka me\u00f0 sams\u00ed\u00f0a reglunni (efni milli gaffaltinda \u00fat a\u00f0 endanum) */
        if (V.ok) { V.fingur = [linuFingur(r.l1), linuFingur(r.l2), r.ti ? taknFingur(r.ti.sk) : null].reduce(function (a, x) { return x && (!a || x.d < a.d) ? x : a; }, null); if (V.fingur && V.fingur.d < BRU - 0.005) { V.ok = false; V.flokkur = "innri"; V.min = V.fingur.d; } }
        if (V.ok) { if (!ojafnt(r)) { ok = true; break; } if (!vara) vara = { r: r, V: V }; saga[saga.length - 1] = "jafnvaegi"; continue; }
        astaeda = "vefur"; saga[saga.length - 1] = "vefur:" + V.flokkur + ":" + f2(V.min);
      } else {
        if (!hettaVandi(r)) { if (!ojafnt(r)) { ok = true; break; } if (!vara) vara = { r: r, V: null }; saga[saga.length - 1] = "jafnvaegi"; continue; }
        astaeda = "gat";
      }
      if (T && r.S <= minS + 1e-9 && (!r.l1 || r.cap1 <= min1 + 1e-6)) break;
      if (kv < 0.3) break;
    }
    if (!ok && vara) { ok = true; r = vara.r; V = vara.V; }
    var R0 = ok ? r : sidastaR;  /* a\u00f0eins \u00fatlit sem var sett saman til enda (r getur h\u00e6tt \u00e1\u00f0ur en l\u00ednurnar f\u00e1 sta\u00f0) */
    U.l1 = R0 && R0.l1; U.l2 = R0 && R0.l2; U.ti = R0 && R0.ti; U.linaP = R0 && R0.linaP; U.l2skorid = !!(sk && U.l2);
    U.cap1 = R0 ? R0.cap1 : 0; U.cap2 = R0 ? R0.cap2 : 0;
    U.vefur = ok ? V : sidastaV; U.umferdir = it; U.hStafa = +hs1.h.toFixed(1);
    if (!ok) {
      if (astaeda === "eyja") U.villur.push({ kodi: "eyja", takn: (U.vefur && U.vefur.eyjur.join(" ")) || "" });
      else if (astaeda === "takn") U.villur.push({ kodi: T && !t1 ? "takn_litid" : "takn_of_langt", takn: T ? T.heiti : "", minst: Math.ceil(minS) });
      else if (astaeda === "min2" || astaeda === "bil2") U.villur.push(sk ? { kodi: "undir_smatt", minst: Math.ceil(min2 * 10) / 10, takn: hs2.h > MIN_SKORID ? hs2.c : "" } : { kodi: "undir_langt" });
      else if (astaeda === "min1" || astaeda === "bil") {
        if (sk) U.villur.push({ kodi: T ? "takn_of_langt" : "of_smatt", minst: Math.ceil(min1 * 10) / 10, takn: T ? T.heiti : (hs1.h > MIN_SKORID ? hs1.c : "") });
        else U.villur.push({ kodi: T ? "takn_of_langt" : "of_langt", grafid: true, takn: T ? T.heiti : "" });
      }
      else U.villur.push({ kodi: T ? "takn_of_langt" : "of_langt", takn: T ? T.heiti : "", grafid: !sk });
    }
    U.ok = !U.villur.length;
    return U;
  }
  /* t\u00e1kn og l\u00edna sem sl\u00f3\u00f0 (mm, hnit pl\u00f6tunnar); skori\u00f0: marghyrningar skur\u00f0ar\u00fatg\u00e1funnar, grafi\u00f0: upprunalegir ferlar */
  function aukaD(U, dx, dy) {
    if (!U || !U.nyr) return "";
    dx = dx || 0; dy = dy || 0;
    var d = "";
    if (U.ti) {
      if (U.ti.sk) U.ti.sk.hopar.forEach(function (q) { d += polysD(q.polys, U.ti.x + dx, U.ti.y + dy); });
      else d += taknD(U.ti.T, U.ti.S, U.ti.x + dx, U.ti.y + dy);
    }
    if (U.linaP) d += polysD([U.linaP], dx, dy);
    return d;
  }

  /* ---------------------------------------------------------------- framlei\u00f0sluskr\u00e1, n\u00fdja lei\u00f0in */
  function spec2(U, lysing) {
    if (!U || !U.ok || (!U.l1 && !U.ti)) return null;
    var s = U.s, g = U.g, P = g.plata, B = g.bak, hl = [], dxP = -P.x, dyP = -P.y;
    var bx = P.w + BIL_SKRA, dxB = B ? bx - B.x : 0, dyB = B ? -B.y : 0, lag = g.skorid ? "SKERA-INNRA" : "GRAFA";
    hl.push({ gerd: "rett", lag: "SKERA-YTRA", hopur: "PLATA", x: 0, y: 0, w: +P.w.toFixed(3), h: +P.h.toFixed(3), r: HORN });
    if (U.ti) {
      var dT = U.ti.sk ? "" : taknD(U.ti.T, U.ti.S, U.ti.x + dxP, U.ti.y + dyP);
      if (U.ti.sk) U.ti.sk.hopar.forEach(function (q) { dT += polysD(q.polys, U.ti.x + dxP, U.ti.y + dyP); });
      hl.push({ gerd: "slod", lag: lag, hopur: "PLATA", d: dT, takn: U.ti.T.kodi });
    }
    if (U.l1) hl.push(linuHlutur(U.l1, lag, dxP, dyP));
    if (U.linaP) hl.push({ gerd: "slod", lag: lag, hopur: "PLATA", d: polysD([U.linaP], dxP, dyP) });
    if (U.l2) hl.push(linuHlutur(U.l2, lag, dxP, dyP));
    if (g.rammiLina) hl.push({ gerd: "rett", lag: "LINA", hopur: "PLATA", x: +(g.rammiLina.x + dxP).toFixed(3), y: +(g.rammiLina.y + dyP).toFixed(3), w: +g.rammiLina.w.toFixed(3), h: +g.rammiLina.h.toFixed(3), r: g.rammiLina.r });
    g.got.forEach(function (p) { hl.push({ gerd: "hringur", lag: "SKERA-INNRA", hopur: "PLATA", cx: +(p[0] + dxP).toFixed(3), cy: +(p[1] + dyP).toFixed(3), r: GAT_R }); });
    if (B) {
      hl.push({ gerd: "rett", lag: "SKERA-YTRA", hopur: "BAK", x: bx, y: 0, w: +B.w.toFixed(3), h: +B.h.toFixed(3), r: HORN });
      g.got.forEach(function (p) { hl.push({ gerd: "hringur", lag: "SKERA-INNRA", hopur: "BAK", cx: +(p[0] + dxB).toFixed(3), cy: +(p[1] + dyB).toFixed(3), r: GAT_R }); });
    }
    var efni = s.gerd === "tvilitt" ? "tvilitt-" + s.litur : (s.gerd === "hnota" ? "hnota-" : s.gerd === "akryl" ? "akryl-" + s.bak + "-" : "") + s.plata;
    var mm2 = function (v) { return String(Math.round(v * 10) / 10).replace(".", ","); };
    var ly = [["Ger\u00f0", GERD_HEITI[s.gerd]]];
    if (g.skorid) ly.push(["PLATA", (AKRYL[s.plata] || {}).heiti + " akr\u00fdl 3 mm, " + mm2(P.w) + " x " + mm2(P.h) + " mm, allt skori\u00f0 \u00ed gegn"]);
    else if (s.gerd !== "tvilitt") ly.push(["PLATA", (AKRYL[s.plata] || {}).heiti + " akr\u00fdl 3 mm, " + mm2(P.w) + " x " + mm2(P.h) + " mm, allt grafi\u00f0"]);
    else ly.push(["PLATA", "Tv\u00edlitt akr\u00fdl " + (TVILITT[s.litur] || {}).heiti + " 1,6 mm, " + mm2(P.w) + " x " + mm2(P.h) + " mm, allt grafi\u00f0"]);
    if (B) ly.push(["BAK", (s.gerd === "hnota" ? "Hnota 3 mm" : (AKRYL[s.bak] || {}).heiti + " akr\u00fdl 3 mm") + ", " + mm2(B.w) + " x " + mm2(B.h) + " mm, x " + mm2(bx) + " mm \u00ed skr\u00e1nni"]);
    ly.push(["Festing", FESTING[s.festing || "lim"] + (g.got.length ? ", " + g.got.length + " g\u00f6t 8 mm" + (B ? " \u00ed gegnum b\u00e6\u00f0i l\u00f6g" : "") : "")]);
    if (U.ti) ly.push(["T\u00e1kn", U.ti.T.kodi + " " + U.ti.T.heiti + ", " + mm2(U.ti.S) + " mm, " + (U.stada === "vinstri" ? "vinstra megin" : (U.stada === "eitt" ? "eitt s\u00e9r" : "fyrir ofan texta")) + ", " +
      (U.ti.sk ? "skori\u00f0 \u00ed gegn" + (U.ti.sk.bryr ? ", " + U.ti.sk.bryr + " br\u00fdr " + mm2(BRU_EYJA) + " mm \u00e1 eyjum" : "") : "grafi\u00f0")]);
    if (U.l1) ly.push(["Texti", U.texti + (g.skorid ? ", " + mm2(U.cap1) + " mm" : "")]);
    if (U.linaP) ly.push(["L\u00edna", g.skorid ? "skorin rauf " + mm2(LINA_SK) + " mm" : "grafin " + mm2(LINA_GR) + " mm"]);
    if (U.l2) ly.push(["Texti undir", U.undir + (g.skorid ? " (skorinn, " + mm2(U.cap2) + " mm)" : " (grafinn)")]);
    if (!g.skorid || s.letur === "didot") ly.push(["Letur", leturLysing(s, g.skorid)]);
    if (g.rammiLina) ly.push(["Rammi", "LINA, " + mm2(g.rammiLina.x - P.x) + " mm fr\u00e1 br\u00fan"]);
    if (U.vefur) {
      var ymm = function (v) { return v >= LEIT ? "> " + LEIT : mm2(v); };
      ly.push(["Minnsta efni milli skur\u00f0a", ymm(U.vefur.milli.d) + " mm (l\u00e1gmark " + mm2(VEFUR) + " mm)"]);
      if (U.vefur.par) ly.push(["Minnsta bil milli stafa", ymm(U.vefur.par.d) + " mm (l\u00e1gmark " + mm2(U.vefur.golfMilli) + " mm, 5 % af stafah\u00e6\u00f0)"]);
      ly.push(["Mj\u00f3sta br\u00fa", ymm(Math.min(U.vefur.innri.d, U.vefur.fingur ? U.vefur.fingur.d : LEIT)) + " mm (l\u00e1gmark " + mm2(BRU) + " mm)"]);
    }
    (lysing || []).forEach(function (x) { ly.push(x); });
    var heiti = U.texti || (U.ti ? U.ti.T.heiti : "");
    return {
      vara: s.vara || "herbergisnumer", efni: efni, staerd: s.staerd, ord: heiti,
      titill: (s.heiti || "Herbergisn\u00famer") + " " + heiti + ", " + GERD_HEITI[s.gerd] + ", " + g.b / 10 + " x " + g.h / 10 + " cm",
      snid: SNID, w: +(B ? bx + B.w : P.w).toFixed(3), h: +Math.max(P.h, B ? B.h : 0).toFixed(3),
      lysing: ly,
      gogn: { v: UTGAFA2, gerd: s.gerd, staerd: s.staerd, festing: s.festing || "lim", plata: s.gerd !== "tvilitt" ? s.plata : null, bak: s.gerd === "akryl" ? s.bak : null, grafa: !!s.grafa, undirGrafid: !!s.undirGrafid,
        litur: s.gerd === "tvilitt" ? s.litur : null, letur: s.letur === "didot" ? "didot" : (g.skorid ? "reo" : (s.letur || "reo")), rammi: !!g.rammiLina, texti: U.texti, undir: U.l2 ? U.undir : "",
        takn: U.ti ? U.ti.T.kodi : null, taknStada: U.ti ? U.stada : null, taknMm: U.ti ? U.ti.S : null, lina: !!U.linaP,
        h1: U.l1 ? +U.cap1.toFixed(2) : null, h2: U.l2 ? +U.cap2.toFixed(2) : null, stafabil: U.l1 ? U.l1.stafabil : null,
        vefur: U.vefur ? +U.vefur.milli.d.toFixed(2) : null, bil: U.vefur && U.vefur.par ? +U.vefur.par.d.toFixed(2) : null, bru: U.vefur ? +U.vefur.innri.d.toFixed(2) : null },
      hlutir: hl
    };
  }
  /* skur\u00f0ir skr\u00e1rinnar flokka\u00f0ir eftir \u00fatlitinu: stafir a\u00f0altexta (s), texta undir (u), hlutar t\u00e1kns (t), l\u00edna (l), g\u00f6t */
  function flokkaSkra2(innra, got, U, gotU) {
    var P0 = U.g.plata, hop = {}, rod = [], kassar = [];
    [["s", U.l1], ["u", U.l2]].forEach(function (x) {
      var Ln = x[1], L = Ln && F[Ln.id]; if (!Ln) return;
      Ln.gl.forEach(function (g, i) {
        if (g.bil || !g.g) return;
        var S = stafur(L, g.g); if (!S.bb) return;
        var X = Ln.stafir[i] - P0.x, Y = Ln.y - P0.y, mm = Ln.mm;
        kassar.push({ k: x[0] + i, c: g.c, boga: Math.min(6, 0.25 * mm), x0: X + S.bb.x0 * mm, x1: X + S.bb.x1 * mm, y0: Y + S.bb.y0 * mm, y1: Y + S.bb.y1 * mm });
      });
    });
    var K = U.ti && U.ti.sk ? U.ti.sk.K.map(function (k) { return { ytri: hlidra([k.ytri], U.ti.x - P0.x, U.ti.y - P0.y)[0], holur: hlidra(k.holur, U.ti.x - P0.x, U.ti.y - P0.y) }; }) : [];
    var LB = U.linaP ? kassiAf(hlidra([U.linaP], -P0.x, -P0.y)) : null;
    innra.forEach(function (pl, k) {
      var key, st = "", bg = null, cx = 0, cy = 0, erGat = !!got[k], i, j;
      pl.forEach(function (q) { cx += q[0]; cy += q[1]; }); cx /= pl.length; cy /= pl.length;
      if (!erGat) gotU.forEach(function (p) { if (Math.abs(cx - p[0]) < 0.3 && Math.abs(cy - p[1]) < 0.3) erGat = true; });
      if (erGat) key = "g" + k;
      else {
        var ip = innriPunktur(pl);
        for (i = 0; i < K.length && !key; i++) {
          if (!inniI(ip, K[i].ytri)) continue;
          var iH = false; for (j = 0; j < K[i].holur.length; j++) if (inniI(ip, K[i].holur[j])) iH = true;
          if (!iH) { key = "t" + i; bg = 1.5; st = U.ti.T.kodi; }
        }
        if (!key && LB && ip[0] >= LB.x0 - 0.3 && ip[0] <= LB.x1 + 0.3 && ip[1] >= LB.y0 - 0.3 && ip[1] <= LB.y1 + 0.3) { key = "l"; bg = 1; }
        if (!key) {
          var best = null, bd = 1e9;
          kassar.forEach(function (b) {
            if (ip[0] < b.x0 - 0.3 || ip[0] > b.x1 + 0.3 || ip[1] < b.y0 - 0.3 || ip[1] > b.y1 + 0.3) return;
            var d = Math.abs(ip[0] - (b.x0 + b.x1) / 2) + Math.abs(ip[1] - (b.y0 + b.y1) / 2); if (d < bd) { bd = d; best = b; }
          });
          if (best) { key = best.k; st = best.c; bg = best.boga; } else key = "p" + k;
        }
      }
      if (!hop[key]) { hop[key] = { hopur: key, gat: erGat, stafur: st, polys: [] }; if (bg != null) hop[key].boga = bg; rod.push(key); }
      hop[key].polys.push(pl);
    });
    return rod.map(function (k) { return hop[k]; });
  }
  /* sm\u00e1mynd t\u00e1kns fyrir vali\u00f0 \u00e1 s\u00ed\u00f0unni */
  function taknSvg(kodi, lit) {
    var T = TK[kodi]; if (!T) return "";
    var k = 100, pad = 2;
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + (-pad) + " " + (-pad) + " " + f2(T.w * k + 2 * pad) + " " + f2(T.h * k + 2 * pad) + '" aria-hidden="true" focusable="false"><path d="' + taknD(T, k, 0, 0) + '" fill="' + (lit || "currentColor") + '"/></svg>';
  }
  function taknListi() { return TK_ROD.map(function (k) { var T = TK[k]; return { kodi: k, heiti: T.heiti, birting: T.birting, sk: T.sk, gr: T.gr, w: T.w, h: T.h }; }); }

  /* textinn eins og hann ver\u00f0ur sm\u00ed\u00f0a\u00f0ur: h\u00e1stafir \u00ed Rounded Elegance Open (skori\u00f0, e\u00f0a Tv\u00edlitt me\u00f0 REO) */
  function birta(s, undir) {
    var G = GERDIR[s.gerd], id = leturAf(s, !!(G && G.skorid)), t = hreinsa(undir ? s.undir : s.texti);
    return hastafir(id) ? upp(t) : t;
  }
  var SMHerb = {
    utgafa: UTGAFA, snid: SNID, VEFUR: VEFUR, MJOTT: MJOTT, MIN_SKORID: MIN_SKORID, BIL_HLUTFALL: BIL_HLUTFALL, GAT_R: GAT_R, HETTA_R: HETTA_R,
    upp: upp, birta: birta,
    STAERDIR: STAERDIR, GERDIR: GERDIR, AKRYL: AKRYL, TVILITT: TVILITT, LETUR: LETUR, LETUR_BRYR: LETUR_BRYR, LETUR_HEITI: LETUR_HEITI, leturAf: leturAf, FESTING: FESTING, GERD_HEITI: GERD_HEITI,
    hlada: hlada, skraLetur: skraLetur, lesaLeturTexta: lesaLeturTexta, hefurLetur: hefurLetur,
    rumfraedi: rumfraedi, uppsetning: uppsetning, teikna: teikna, spec: spec, athugaSkra: athugaSkra,
    leyft: function (c, undir) { return (undir ? LEYFT_UNDIR : LEYFT_AD).test(c); },
    hreinsa: hreinsa,
    utgafa2: UTGAFA2, BRU: BRU, LINA_SK: LINA_SK, LINA_GR: LINA_GR,
    hladaTakn: hladaTakn, skraTakn: skraTakn, takn: taknListi, taknSvg: taknSvg, hefurTakn: function () { return TK_ROD.length > 0; },
    _innri: { breikka: breikka, breikkaStaf: breikkaStaf, stafur: stafur, breikkaLinu: breikkaLinu, taknSkurdur: taknSkurdur, taknStenst: taknStenst, linuDX: linuDX, aukaD: aukaD, TK: TK, tappi: tappi, lina: lina, linuPolys: linuPolys, linuD: linuD, vefur: vefur, lesaD: lesaD, flatten: flatten, formPolys: formPolys, hopEfni: hopEfni, F: F }
  };
  W.SMHerb = SMHerb;
  if (typeof module !== "undefined" && module.exports) module.exports = SMHerb;
})(typeof window !== "undefined" ? window : global);
